import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { getApiHeaders } from '../utils/apiHelpers';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { 
  Plus, Search, MoreVertical, Eye, FileText, 
  Image, Trash2, CheckCircle, Clock, AlertCircle, Loader2,
  Upload, X, Download, Package, ArrowRight,
  TrendingUp, TrendingDown, Minus, ShoppingCart, ArrowLeft,
  Info, Share2, Thermometer, Pencil, Save, Copy, History,
  AlertTriangle, Check, RefreshCw, Building, Calendar, DollarSign,
  ChevronLeft, ChevronRight
} from 'lucide-react';
import { toast } from 'sonner';
import { Archive } from 'lucide-react';
import { ArchivioDDT } from '../components/ddt/ArchivioDDT';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const dataBreve = (d) => {
  const s = String(d || '');
  return s.length >= 10 ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : '';
};

const GestioneBollePage = ({ openNuovaBolla = false }) => {
  // State
  const [ddtList, setDdtList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterData, setFilterData] = useState('');
  const [filterFornitore, setFilterFornitore] = useState('');
  const [filterMese, setFilterMese] = useState('');
  const [filterAnno, setFilterAnno] = useState('');
  const [showSoloBozze, setShowSoloBozze] = useState(false);
  const [fornitori, setFornitori] = useState([]);
  const [anniDisponibili, setAnniDisponibili] = useState([]);
  const [ordinaPer, setOrdinaPer] = useState('numero');
  const [ordine, setOrdine] = useState('desc');
  
  // Paginazione
  const PAGE_SIZE = 20;
  const [page, setPage] = useState(1);
  const [totalDdt, setTotalDdt] = useState(0);
  
  // Modal states
  const [showNuovaBolla, setShowNuovaBolla] = useState(false);
  const [showDettaglio, setShowDettaglio] = useState(null);
  const [showImmagine, setShowImmagine] = useState(null);
  const [actionMenuOpen, setActionMenuOpen] = useState(null);
  
  // Vista DDT dettagliata (Apri DDT)
  const [ddtAperto, setDdtAperto] = useState(null);
  const [ddtConforme, setDdtConforme] = useState(true);
  const [prodottiDDT, setProdottiDDT] = useState([]);
  const [savingDDT, setSavingDDT] = useState(false);
  const [confrontoPrezzi, setConfrontoPrezzi] = useState(null);
  const [loadingConfronto, setLoadingConfronto] = useState(false);
  
  // Edit product modal
  const [editingProduct, setEditingProduct] = useState(null);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [newProduct, setNewProduct] = useState({
    nome: '', quantita: '', unita_misura: 'kg', prezzo_unitario: '', lotto: '', scadenza: ''
  });
  
  // Info generali modal
  const [showInfoGenerali, setShowInfoGenerali] = useState(false);
  
  // Nuova Bolla flow states
  const [step, setStep] = useState(1);
  const [ordiniAttesa, setOrdiniAttesa] = useState([]);
  const [loadingOrdini, setLoadingOrdini] = useState(false);
  const [selectedOrdine, setSelectedOrdine] = useState(null);
  
  // Tab state
  const [activeTab, setActiveTab] = useState('ddt'); // 'ddt', 'resi', 'storico_resi'
  const [resiInAttesa, setResiInAttesa] = useState([]);
  const [loadingResi, setLoadingResi] = useState(false);
  const [storicoResi, setStoricoResi] = useState([]);
  const [storicoRiepilogo, setStoricoRiepilogo] = useState(null);
  const [loadingStoricoResi, setLoadingStoricoResi] = useState(false);
  const [filtroStoricoResi, setFiltroStoricoResi] = useState('tutti'); // 'tutti', 'in_attesa', 'completato'
  
  // Upload & Analysis states
  const [uploading, setUploading] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);
  const [analisiResult, setAnalisiResult] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  
  // Upload multiplo
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadQueue, setUploadQueue] = useState([]);
  const [currentUploadIndex, setCurrentUploadIndex] = useState(0);
  const [uploadResults, setUploadResults] = useState([]);
  const [showUploadProgress, setShowUploadProgress] = useState(false);
  
  // Revisione DDT multipli (nuova funzionalità)
  const [analisiMultiple, setAnalisiMultiple] = useState([]); // Array di {file, analisi, base64, status}
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const [showReviewMode, setShowReviewMode] = useState(false);
  
  // Verifica prodotti states
  const [prodottiVerifica, setProdottiVerifica] = useState([]);
  const [showStoricoModal, setShowStoricoModal] = useState(false);
  const [prodottoSelezionato, setProdottoSelezionato] = useState(null);
  const [storicoAcquisti, setStoricoAcquisti] = useState([]);
  
  // Confronto states
  const [confronto, setConfronto] = useState(null);
  
  const fileInputRef = useRef(null);
  const multiFileInputRef = useRef(null);

  // Load data on mount
  useEffect(() => {
    loadDDT();
    loadFornitori();
    loadResiInAttesa();
  }, []);

  // Apri automaticamente Nuova Bolla se richiesto
  useEffect(() => {
    if (openNuovaBolla) {
      setShowNuovaBolla(true);
    }
  }, [openNuovaBolla]);

  const loadResiInAttesa = async () => {
    setLoadingResi(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/gestione/resi-fornitore?limit=50`, {
        headers: getApiHeaders()
      });
      
      if (res.data.success) {
        // Solo resi in attesa di nota credito
        const resiPending = (res.data.resi || []).filter(r => !r.nota_credito_ricevuta);
        setResiInAttesa(resiPending);
      }
    } catch (error) {
      console.error('Errore caricamento resi:', error);
    } finally {
      setLoadingResi(false);
    }
  };

  const toggleNotaCreditoReso = async (resoId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/gestione/resi-fornitore/${resoId}/nota-credito?nota_credito_ricevuta=true`,
        {},
        { headers: getApiHeaders() }
      );
      toast.success('Nota credito segnata come ricevuta');
      loadResiInAttesa();
      loadStoricoResi();
    } catch (error) {
      toast.error('Errore nell\'aggiornamento');
    }
  };

  const deleteReso = async (resoId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo reso? L\'operazione non è reversibile.')) {
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${API}/gestione/resi-fornitore/${resoId}`,
        { headers: getApiHeaders() }
      );
      toast.success('Reso eliminato con successo');
      loadResiInAttesa();
      loadStoricoResi();
    } catch (error) {
      toast.error('Errore nell\'eliminazione del reso');
    }
  };

  const loadStoricoResi = async (stato = null) => {
    setLoadingStoricoResi(true);
    try {
      const token = localStorage.getItem('token');
      const statoParam = stato || filtroStoricoResi;
      const res = await axios.get(`${API}/gestione/resi-fornitore/storico?stato=${statoParam}&limit=100`, {
        headers: getApiHeaders()
      });
      
      if (res.data.success) {
        setStoricoResi(res.data.resi || []);
        setStoricoRiepilogo(res.data.riepilogo || null);
      }
    } catch (error) {
      console.error('Errore caricamento storico resi:', error);
    } finally {
      setLoadingStoricoResi(false);
    }
  };

  const loadDDT = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      if (filterData) params.append('data_inizio', filterData);
      if (filterFornitore) params.append('fornitore', filterFornitore);
      if (filterMese) params.append('mese', filterMese);
      if (filterAnno) params.append('anno', filterAnno);
      params.append('ordina_per', ordinaPer);
      params.append('ordine', ordine);
      params.append('skip', String((page - 1) * PAGE_SIZE));
      params.append('limit', String(PAGE_SIZE));
      if (searchTerm) params.append('search', searchTerm);
      if (showSoloBozze) params.append('solo_bozze', 'true');
      
      const res = await axios.get(`${API}/gestione/ddt?${params.toString()}`, {
        headers: getApiHeaders()
      });
      
      let ddt = res.data.ddt || [];
      setTotalDdt(res.data.total || 0);
      
      // Salva i filtri disponibili dal backend
      if (res.data.filtri_disponibili) {
        if (res.data.filtri_disponibili.fornitori) {
          setFornitori(res.data.filtri_disponibili.fornitori);
        }
        if (res.data.filtri_disponibili.anni) {
          setAnniDisponibili(res.data.filtri_disponibili.anni);
        }
      }
      
      setDdtList(ddt);
    } catch (error) {
      console.error('Errore caricamento DDT:', error);
      // Non mostrare errore - semplicemente lista vuota
      setDdtList([]);
    } finally {
      setLoading(false);
    }
  };

  const loadFornitori = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/gestione/fornitori`, {
        headers: getApiHeaders()
      });
      setFornitori(res.data || []);
    } catch (error) {
      console.error('Errore caricamento fornitori:', error);
      setFornitori([]);
    }
  };

  const loadOrdiniAttesa = async () => {
    try {
      setLoadingOrdini(true);
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/gestione/ddt?solo_attesa=true`, {
        headers: getApiHeaders()
      });
      const inAttesa = (res.data.ddt || []).filter(d => d.status === 'in_attesa');
      setOrdiniAttesa(inAttesa);
    } catch (error) {
      console.error('Errore caricamento ordini:', error);
      // Non mostrare errore - lista vuota
      setOrdiniAttesa([]);
    } finally {
      setLoadingOrdini(false);
    }
  };

  // Load confronto prezzi when DDT is opened
  const loadConfrontoPrezzi = useCallback(async (ddtId) => {
    try {
      setLoadingConfronto(true);
      // Cerca prima i dati tenant, poi quelli standard  
      const token = localStorage.getItem('tenant_token') || localStorage.getItem('token');
      const userStr = localStorage.getItem('tenant_user') || localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : {};
      const tenantDb = user.tenants && user.tenants[0] ? user.tenants[0].database_name : null;
      
      const headers = getApiHeaders();
      if (tenantDb) {
        headers['X-Tenant-DB'] = tenantDb.replace('tenant_', '');
      }
      
      const res = await axios.get(`${API}/gestione/ddt/${ddtId}/confronto-prezzi`, {
        headers
      });
      setConfrontoPrezzi(res.data.confronti || []);  // Nota: backend restituisce 'confronti' non 'confronto'
    } catch (error) {
      console.error('Errore caricamento confronto prezzi:', error);
    } finally {
      setLoadingConfronto(false);
    }
  }, []);

  useEffect(() => {
    loadDDT();
  }, [filterData, filterFornitore, filterMese, filterAnno, showSoloBozze, searchTerm, ordinaPer, ordine, page]);

  // Torna a pagina 1 quando cambiano filtri o ricerca
  useEffect(() => {
    setPage(1);
  }, [filterData, filterFornitore, filterMese, filterAnno, showSoloBozze, searchTerm]);

  useEffect(() => {
    if (showNuovaBolla) {
      loadOrdiniAttesa();
      setStep(1);
      setSelectedOrdine(null);
      setSelectedFile(null);
      setPreviewUrl(null);
      setImageBase64ForDB(null);
      setAnalisiResult(null);
      setConfronto(null);
    }
  }, [showNuovaBolla]);

  // State per salvare il base64 dell'immagine per il database
  const [imageBase64ForDB, setImageBase64ForDB] = useState(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Determina il tipo di file
      const fileName = file.name.toLowerCase();
      const fileType = file.type;
      
      let tipoFile = 'image';
      if (fileName.endsWith('.pdf') || fileType === 'application/pdf') {
        tipoFile = 'pdf';
      } else if (fileName.endsWith('.xlsx') || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        tipoFile = 'xlsx';
      } else if (fileName.endsWith('.xls') || fileType === 'application/vnd.ms-excel') {
        tipoFile = 'xls';
      }
      
      setSelectedFile({ file, tipoFile, name: file.name });
      
      // Preview solo per immagini - salva anche il base64 per il database
      if (tipoFile === 'image') {
        setPreviewUrl(URL.createObjectURL(file));
        // Converti in base64 per salvare nel DB
        const reader = new FileReader();
        reader.onloadend = () => {
          setImageBase64ForDB(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setPreviewUrl(null);
        setImageBase64ForDB(null);
      }
      
      setAnalisiResult(null);
      setConfronto(null);
    }
  };

  // Gestione upload multiplo
  const handleMultipleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    
    const processedFiles = files.map(file => {
      const fileName = file.name.toLowerCase();
      const fileType = file.type;
      
      let tipoFile = 'image';
      if (fileName.endsWith('.pdf') || fileType === 'application/pdf') {
        tipoFile = 'pdf';
      } else if (fileName.endsWith('.xlsx') || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        tipoFile = 'xlsx';
      } else if (fileName.endsWith('.xls') || fileType === 'application/vnd.ms-excel') {
        tipoFile = 'xls';
      }
      
      return { file, tipoFile, name: file.name, status: 'pending' };
    });
    
    setSelectedFiles(processedFiles);
    setUploadResults([]);
    setCurrentUploadIndex(0);
  };

  // Elabora tutti i file in sequenza - ANALIZZA TUTTI, POI MOSTRA UNO ALLA VOLTA
  const processAllFiles = async () => {
    if (selectedFiles.length === 0) return;
    
    setShowUploadProgress(true);
    setUploading(true);
    const analizzati = [];
    
    for (let i = 0; i < selectedFiles.length; i++) {
      setCurrentUploadIndex(i);
      const fileData = selectedFiles[i];
      
      // Aggiorna stato file corrente
      setSelectedFiles(prev => prev.map((f, idx) => 
        idx === i ? { ...f, status: 'processing' } : f
      ));
      
      try {
        // Solo analizza, non creare
        const result = await analyzeFileOnly(fileData);
        
        // Prepara prodotti per verifica (come nel flusso singolo)
        const prodottiPreparati = (result.analisi.prodotti || []).map((p, idx) => ({
          ...p,
          id: `prod_${idx}_${Date.now()}`,
          arrivato: true,
          stato_consegna: 'ricevuto',
          quantita_originale: p.quantita,
          quantita_ricevuta: p.quantita,
          prezzo_originale: p.prezzo_unitario,
          totale: (p.quantita || 0) * (p.prezzo_unitario || 0),
          motivo_reso: '',
          confronto_prezzo: null
        }));
        
        analizzati.push({
          file: fileData,
          analisi: result.analisi,
          base64: result.base64,
          prodotti: prodottiPreparati,
          status: 'analyzed',
          saved: false
        });
        
        setSelectedFiles(prev => prev.map((f, idx) => 
          idx === i ? { ...f, status: 'success' } : f
        ));
      } catch (error) {
        console.error(`Errore analisi ${fileData.name}:`, error);
        
        analizzati.push({
          file: fileData,
          analisi: null,
          base64: null,
          prodotti: [],
          status: 'error',
          error: error.message,
          saved: false
        });
        
        setSelectedFiles(prev => prev.map((f, idx) => 
          idx === i ? { ...f, status: 'error', error: error.message } : f
        ));
      }
    }
    
    setUploading(false);
    setAnalisiMultiple(analizzati);
    
    // Trova il primo DDT analizzato con successo
    const primoValido = analizzati.findIndex(a => a.status === 'analyzed');
    if (primoValido >= 0) {
      setCurrentReviewIndex(primoValido);
      // Carica i prodotti del primo DDT nello stato di verifica
      setProdottiVerifica(analizzati[primoValido].prodotti);
      setAnalisiResult(analizzati[primoValido].analisi);
      setImageBase64ForDB(analizzati[primoValido].base64);
      setShowReviewMode(true);
      setStep(3); // Vai allo step di verifica prodotti
      toast.success(`${analizzati.filter(a => a.status === 'analyzed').length} DDT analizzati. Verifica il primo.`);
    } else {
      toast.error('Nessun DDT analizzato con successo');
    }
  };

  // Analizza solo senza creare DDT
  const analyzeFileOnly = async (fileData) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onloadend = async () => {
        try {
          const base64Data = reader.result;
          const token = localStorage.getItem('token');
          const headers = getApiHeaders();
          
          // Usa endpoint corretto per analisi
          const endpoint = fileData.tipoFile === 'image' 
            ? `${API}/gestione/ddt/analizza-immagine`
            : `${API}/gestione/ddt/analizza-documento`;
          
          const payload = fileData.tipoFile === 'image' 
            ? { immagine_base64: base64Data }
            : { file_base64: base64Data, tipo_file: fileData.tipoFile };
          
          const analisiRes = await axios.post(endpoint, payload, { 
            headers,
            timeout: 180000 
          });
          
          if (!analisiRes.data.success && !analisiRes.data.analisi) {
            throw new Error('Analisi fallita');
          }
          
          resolve({
            analisi: analisiRes.data.analisi || analisiRes.data.dati,
            base64: base64Data
          });
        } catch (error) {
          reject(error);
        }
      };
      
      reader.onerror = () => reject(new Error('Errore lettura file'));
      reader.readAsDataURL(fileData.file);
    });
  };

  // Salva il DDT corrente e passa al successivo (per upload multiplo)
  const salvaDDTCorrenteEProsegui = async () => {
    if (!showReviewMode || analisiMultiple.length === 0) return;
    
    const currentDDT = analisiMultiple[currentReviewIndex];
    if (!currentDDT || currentDDT.status !== 'analyzed') {
      passaAlProssimoDDT();
      return;
    }
    
    // Prepara i prodotti verificati
    const prodottiDaSalvare = prodottiVerifica.filter(p => p.arrivato);
    if (prodottiDaSalvare.length === 0) {
      toast.error('Seleziona almeno un prodotto');
      return;
    }
    
    try {
      setSavingDDT(true);
      const token = localStorage.getItem('token');
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      
      // Aggiorna analisi con prodotti verificati
      const analisiAggiornata = {
        ...currentDDT.analisi,
        prodotti: prodottiDaSalvare.map(p => ({
          nome: p.nome,
          quantita: p.quantita,
          unita_misura: p.unita_misura,
          prezzo_unitario: p.prezzo_unitario,
          totale: p.totale || (p.quantita * p.prezzo_unitario),
          lotto: p.lotto,
          scadenza: p.scadenza,
          codice_prodotto: p.codice_prodotto
        })),
        totale_documento: prodottiDaSalvare.reduce((sum, p) => sum + (p.totale || 0), 0)
      };
      
      const res = await axios.post(`${API}/gestione/ddt/crea-da-analisi`, {
        analisi: analisiAggiornata,
        immagine_url: currentDDT.base64,
        creato_da: userData.username || 'Caricamento multiplo'
      }, {
        headers: getApiHeaders()
      });
      
      if (res.data.duplicato) {
        toast.warning(`DDT già presente: ${res.data.messaggio}`);
      } else {
        // Avviso se è stato creato un nuovo fornitore
        if (res.data.fornitore_nuovo) {
          toast.info(`🆕 Nuovo fornitore creato: ${res.data.fornitore || analisiAggiornata.fornitore}`, {
            duration: 5000
          });
        }
        toast.success(`DDT salvato con ${prodottiDaSalvare.length} prodotti`);
      }
      
      // Marca come salvato
      setAnalisiMultiple(prev => prev.map((item, i) => 
        i === currentReviewIndex ? { ...item, saved: true } : item
      ));
      
      // Passa al prossimo
      passaAlProssimoDDT();
      
    } catch (error) {
      console.error('Errore salvataggio:', error);
      toast.error('Errore durante il salvataggio');
    } finally {
      setSavingDDT(false);
    }
  };

  // Salta il DDT corrente (non salvare)
  const saltaDDTCorrente = () => {
    toast.info('DDT saltato');
    passaAlProssimoDDT();
  };

  // Passa al prossimo DDT da verificare
  const passaAlProssimoDDT = () => {
    // Trova il prossimo DDT non ancora processato
    const prossimoIndex = analisiMultiple.findIndex((a, i) => 
      i > currentReviewIndex && a.status === 'analyzed' && !a.saved
    );
    
    if (prossimoIndex >= 0) {
      // Carica il prossimo DDT
      setCurrentReviewIndex(prossimoIndex);
      setProdottiVerifica(analisiMultiple[prossimoIndex].prodotti);
      setAnalisiResult(analisiMultiple[prossimoIndex].analisi);
      setImageBase64ForDB(analisiMultiple[prossimoIndex].base64);
    } else {
      // Tutti i DDT sono stati processati
      const salvati = analisiMultiple.filter(a => a.saved).length;
      const totali = analisiMultiple.filter(a => a.status === 'analyzed').length;
      toast.success(`Completato! ${salvati}/${totali} DDT salvati`);
      loadDDT();
      resetMultiUpload();
    }
  };

  // Reset upload multiplo
  const resetMultiUpload = () => {
    setSelectedFiles([]);
    setUploadResults([]);
    setAnalisiMultiple([]);
    setShowReviewMode(false);
    setCurrentReviewIndex(0);
    setProdottiVerifica([]);
    setAnalisiResult(null);
    setImageBase64ForDB(null);
    setStep(1);
    setShowNuovaBolla(false);
  };

  // Info DDT corrente in revisione
  const getDDTCorrenteInfo = () => {
    if (!showReviewMode || analisiMultiple.length === 0) return null;
    const current = analisiMultiple[currentReviewIndex];
    const totali = analisiMultiple.filter(a => a.status === 'analyzed').length;
    const processati = analisiMultiple.filter(a => a.saved).length;
    const corrente = analisiMultiple.filter((a, i) => i <= currentReviewIndex && a.status === 'analyzed').length;
    return {
      fileName: current?.file?.name,
      corrente,
      totali,
      processati
    };
  };

  // Analizza e crea DDT per singolo file
  const analyzeAndCreateDDT = async (fileData, forzaCreazione = false) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onloadend = async () => {
        try {
          const base64Data = reader.result;
          const token = localStorage.getItem('token');
          const headers = getApiHeaders();
          
          // Analizza
          const endpoint = `${API}/gestione/ddt/analizza-immagine`;
          const payload = fileData.tipoFile === 'image' 
            ? { immagine_base64: base64Data }
            : { file_base64: base64Data, tipo_file: fileData.tipoFile };
          
          const analisiRes = await axios.post(endpoint, payload, { headers, timeout: 180000 });
          
          if (!analisiRes.data.success && !analisiRes.data.analisi) {
            throw new Error('Analisi fallita');
          }
          
          // Crea DDT - includi l'immagine originale
          const creaRes = await axios.post(`${API}/gestione/ddt/crea-da-analisi`, {
            analisi: analisiRes.data.analisi || analisiRes.data.dati,
            immagine_url: base64Data,  // Salva l'immagine originale
            creato_da: 'Caricamento multiplo',
            forza_creazione: forzaCreazione
          }, { headers });
          
          // Gestisci risposta duplicato
          if (creaRes.data.duplicato) {
            const err = new Error('DUPLICATO');
            err.duplicato = true;
            err.ddt_esistente = creaRes.data.ddt_esistente;
            err.messaggio = creaRes.data.messaggio;
            throw err;
          }
          
          // Passa info nuovo fornitore al resolve
          resolve({
            ...creaRes.data,
            fornitore_nuovo: creaRes.data.fornitore_nuovo,
            fornitore: creaRes.data.fornitore
          });
        } catch (error) {
          reject(error);
        }
      };
      
      reader.onerror = () => reject(new Error('Errore lettura file'));
      reader.readAsDataURL(fileData.file);
    });
  };

  const getFileIcon = (tipoFile) => {
    switch (tipoFile) {
      case 'pdf': return '📄';
      case 'xls':
      case 'xlsx': return '📊';
      default: return '🖼️';
    }
  };

  const uploadAndAnalyze = async () => {
    if (!selectedFile) {
      toast.error('Seleziona un file');
      return;
    }

    try {
      setUploading(true);
      setAnalyzing(true);
      
      const token = localStorage.getItem('token');
      const { file, tipoFile } = selectedFile;
      
      const reader = new FileReader();
      reader.onloadend = async () => {
        try {
          const base64Data = reader.result;
          
          // Usa endpoint diverso in base al tipo di file
          let endpoint, payload;
          
          if (tipoFile === 'image') {
            endpoint = `${API}/gestione/ddt/analizza-immagine`;
            payload = { immagine_base64: base64Data };
          } else {
            endpoint = `${API}/gestione/ddt/analizza-documento`;
            payload = { file_base64: base64Data, tipo_file: tipoFile };
          }
          
          const res = await axios.post(endpoint, payload, { 
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            timeout: 180000 // 3 minuti per PDF/Excel
          });
          
          if (res.data.success) {
            const analisi = res.data.analisi;
            setAnalisiResult(analisi);
            
            // Prepara i prodotti per la verifica con stato consegna
            let prodottiPerVerifica = (analisi.prodotti || []).map((p, idx) => ({
              ...p,
              id: `prod_${idx}_${Date.now()}`,
              arrivato: true, // Retrocompatibilità
              stato_consegna: 'ricevuto', // ricevuto, non_consegnato, reso, parziale
              quantita_originale: p.quantita,
              quantita_ricevuta: p.quantita, // Inizialmente uguale
              prezzo_originale: p.prezzo_unitario,
              motivo_reso: '',
              nota_credito_ricevuta: false,
              confronto_prezzo: null // Will be populated below
            }));
            
            // Confronta prezzi con acquisti precedenti
            try {
              // Cerca prima i dati tenant, poi quelli standard
              const token = localStorage.getItem('tenant_token') || localStorage.getItem('token');
              const userStr = localStorage.getItem('tenant_user') || localStorage.getItem('user');
              const user = userStr ? JSON.parse(userStr) : {};
              const tenantDb = user.tenants && user.tenants[0] ? user.tenants[0].database_name : null;
              
              const headers = getApiHeaders();
              if (tenantDb) {
                headers['X-Tenant-DB'] = tenantDb.replace('tenant_', '');
              }
              
              const confrontoRes = await axios.post(
                `${API}/gestione/prodotti/confronta-prezzi-batch-v2`,
                { 
                  prodotti: prodottiPerVerifica,
                  fornitore: analisi.fornitore || '',
                  data_ddt: analisi.data_ddt || analisi.data || ''
                },
                { headers }
              );
              
              if (confrontoRes.data.success) {
                const confronti = confrontoRes.data.confronti;
                prodottiPerVerifica = prodottiPerVerifica.map((p, idx) => ({
                  ...p,
                  confronto_prezzo: confronti[idx] || null
                }));
              }
            } catch (confErr) {
              console.log('Confronto prezzi non disponibile:', confErr);
              // Fallback: calcola comunque il totale per ogni prodotto
              prodottiPerVerifica = prodottiPerVerifica.map(p => ({
                ...p,
                totale: (p.quantita || 0) * (p.prezzo_unitario || 0)
              }));
            }
            
            // Assicurati che ogni prodotto abbia il totale calcolato
            prodottiPerVerifica = prodottiPerVerifica.map(p => ({
              ...p,
              totale: (p.quantita || 0) * (p.prezzo_unitario || 0)
            }));
            
            setProdottiVerifica(prodottiPerVerifica);
            
            // Conta variazioni di prezzo
            const variazioni = prodottiPerVerifica.filter(p => 
              p.confronto_prezzo?.trend === 'aumento' || p.confronto_prezzo?.trend === 'diminuzione'
            ).length;
            
            if (variazioni > 0) {
              toast.success(`Analisi completata: ${prodottiPerVerifica.length} prodotti. ⚠️ ${variazioni} variazioni di prezzo rilevate!`);
            } else {
              toast.success(`Analisi completata: ${prodottiPerVerifica.length} prodotti trovati. Verifica i dati.`);
            }
            
            // Se c'è un ordine selezionato, confronta con il DDT ricevuto
            if (selectedOrdine) {
              confrontaOrdineConDDT(selectedOrdine, analisi);
            }
            
            // Vai sempre allo step di verifica (step 3)
            setStep(3);
          } else {
            toast.error(res.data.detail || 'Errore durante l\'analisi');
          }
        } catch (error) {
          console.error('Errore analisi:', error);
          toast.error(error.response?.data?.detail || 'Errore durante l\'analisi del documento');
        } finally {
          setUploading(false);
          setAnalyzing(false);
        }
      };
      
      reader.onerror = () => {
        toast.error('Errore nella lettura del file');
        setUploading(false);
        setAnalyzing(false);
      };
      
      reader.readAsDataURL(file);
      
    } catch (error) {
      console.error('Errore upload:', error);
      toast.error('Errore durante l\'upload');
      setUploading(false);
      setAnalyzing(false);
    }
  };


  const confrontaOrdineConDDT = (ordine, analisi) => {
    const prodottiOrdinati = ordine.prodotti_attesi || ordine.prodotti || [];
    const prodottiRicevuti = analisi.prodotti || [];
    
    const confrontoItems = [];
    
    prodottiOrdinati.forEach(ordinato => {
      const nomeOrd = ordinato.nome?.toLowerCase() || '';
      const ricevuto = prodottiRicevuti.find(r => {
        const nomeRic = r.nome?.toLowerCase() || '';
        return nomeRic.includes(nomeOrd) || nomeOrd.includes(nomeRic);
      });
      
      if (ricevuto) {
        const prezzoOrdinato = parseFloat(ordinato.prezzo_stimato || ordinato.prezzo_unitario) || 0;
        const prezzoRicevuto = parseFloat(ricevuto.prezzo_unitario) || 0;
        const variazionePrezzo = prezzoOrdinato > 0 ? ((prezzoRicevuto - prezzoOrdinato) / prezzoOrdinato * 100) : 0;
        
        const qtaOrdinata = parseFloat(ordinato.quantita) || 0;
        const qtaRicevuta = parseFloat(ricevuto.quantita) || 0;
        const variazioneQta = qtaOrdinata > 0 ? ((qtaRicevuta - qtaOrdinata) / qtaOrdinata * 100) : 0;
        
        confrontoItems.push({
          nome: ordinato.nome,
          ordinato: { quantita: qtaOrdinata, prezzo: prezzoOrdinato, unita: ordinato.unita_misura },
          ricevuto: { quantita: qtaRicevuta, prezzo: prezzoRicevuto, unita: ricevuto.unita_misura, lotto: ricevuto.lotto, scadenza: ricevuto.scadenza },
          variazionePrezzo, variazioneQta,
          status: variazionePrezzo !== 0 || variazioneQta !== 0 ? 'variazione' : 'ok'
        });
      } else {
        confrontoItems.push({
          nome: ordinato.nome,
          ordinato: { quantita: ordinato.quantita, prezzo: ordinato.prezzo_unitario, unita: ordinato.unita_misura },
          ricevuto: null,
          status: 'mancante'
        });
      }
    });
    
    prodottiRicevuti.forEach(ricevuto => {
      const nomeRic = ricevuto.nome?.toLowerCase() || '';
      const giàAggiunto = confrontoItems.some(c => {
        const nomeConf = c.nome?.toLowerCase() || '';
        return nomeConf.includes(nomeRic) || nomeRic.includes(nomeConf);
      });
      
      if (!giàAggiunto) {
        confrontoItems.push({
          nome: ricevuto.nome,
          ordinato: null,
          ricevuto: { quantita: ricevuto.quantita, prezzo: ricevuto.prezzo_unitario, unita: ricevuto.unita_misura, lotto: ricevuto.lotto, scadenza: ricevuto.scadenza },
          status: 'extra'
        });
      }
    });
    
    setConfronto({
      items: confrontoItems,
      totaleOrdinato: prodottiOrdinati.reduce((sum, p) => sum + ((parseFloat(p.quantita) || 0) * (parseFloat(p.prezzo_stimato || p.prezzo_unitario) || 0)), 0),
      totaleRicevuto: prodottiRicevuti.reduce((sum, p) => sum + ((parseFloat(p.quantita) || 0) * (parseFloat(p.prezzo_unitario) || 0)), 0),
      fornitore: analisi.fornitore || ordine.fornitore,
      dataDDT: analisi.data_ddt
    });
  };

  const salvaDDT = async (conOrdine = false) => {
    if (savingDDT) return; // Blocca click multipli
    // Usa i prodotti verificati se presenti, altrimenti i prodotti dall'analisi
    const prodottiDaSalvare = prodottiVerifica.length > 0 
      ? prodottiVerifica.filter(p => p.arrivato) // Solo prodotti spuntati come arrivati
      : (analisiResult?.prodotti || []);
    
    if (prodottiDaSalvare.length === 0) {
      toast.error('Nessun prodotto da salvare. Spunta almeno un prodotto come arrivato.');
      return;
    }

    setSavingDDT(true);
    const loadingToast = toast.loading('Salvataggio DDT in corso...');
    const token = localStorage.getItem('token');
    let payload;
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      
      // Crea analisi aggiornata con i prodotti verificati
      const analisiAggiornata = {
        ...analisiResult,
        prodotti: prodottiDaSalvare.map(p => ({
          nome: p.nome,
          quantita: p.quantita,
          unita_misura: p.unita_misura,
          prezzo_unitario: p.prezzo_unitario,
          totale: p.totale,
          lotto: p.lotto,
          scadenza: p.scadenza,
          codice_prodotto: p.codice_prodotto,
          arrivato: p.arrivato
        })),
        totale_documento: prodottiDaSalvare.reduce((sum, p) => sum + (p.totale || 0), 0)
      };
      
      payload = {
        analisi: analisiAggiornata,
        immagine_url: imageBase64ForDB || null,
        creato_da: userData.username || 'Sistema'
      };
      
      if (conOrdine && selectedOrdine) {
        payload.ordine_riferimento_id = selectedOrdine.id;
        payload.confronto = confronto;
      }
      
      const res = await axios.post(
        `${API}/gestione/ddt/crea-da-analisi`,
        payload,
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      
      if (res.data.duplicato) {
        // DDT già presente - chiedi conferma per sovrascrivere
        const conferma = window.confirm(
          `⚠️ ${res.data.messaggio}\n\nVuoi salvarlo comunque?`
        );
        
        if (conferma) {
          // Riprova con forza_creazione = true
          const payloadForzato = { ...payload, forza_creazione: true };
          const resForzato = await axios.post(
            `${API}/gestione/ddt/crea-da-analisi`,
            payloadForzato,
            { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
          );
          
          if (resForzato.data.success) {
            if (resForzato.data.fornitore_nuovo) {
              toast.info(`🆕 Nuovo fornitore creato: ${resForzato.data.fornitore}`, { duration: 5000 });
            }
            toast.success(`DDT salvato con ${prodottiDaSalvare.length} prodotti`);
            closeModal();
            loadDDT();
          }
        }
        return;
      }
      
      if (res.data.success) {
        // Avviso se è stato creato un nuovo fornitore
        if (res.data.fornitore_nuovo) {
          toast.info(`🆕 Nuovo fornitore creato: ${res.data.fornitore || analisiAggiornata.fornitore}`, {
            duration: 5000
          });
        }
        toast.success(`DDT salvato con ${prodottiDaSalvare.length} prodotti`);
        
        if (conOrdine && selectedOrdine) {
          try {
            await axios.delete(`${API}/gestione/ddt/${selectedOrdine.id}`, {
              headers: getApiHeaders()
            });
          } catch (e) {
            console.error('Errore rimozione ordine attesa:', e);
          }
        }
        
        closeModal();
        loadDDT();
      }
    } catch (error) {
      console.error('Errore salvataggio DDT:', error);
      // Controlla se è un errore di duplicato dal server
      if (error.response?.data?.duplicato) {
        const conferma = window.confirm(
          `⚠️ ${error.response.data.messaggio}\n\nVuoi salvarlo comunque?`
        );
        
        if (conferma) {
          try {
            const payloadForzato = { ...payload, forza_creazione: true };
            const resForzato = await axios.post(
              `${API}/gestione/ddt/crea-da-analisi`,
              payloadForzato,
              { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
            );
            
            if (resForzato.data.success) {
              toast.success(`DDT salvato con ${prodottiDaSalvare.length} prodotti`);
              closeModal();
              loadDDT();
            }
          } catch (e2) {
            toast.error('Errore durante il salvataggio forzato');
          }
        }
      } else {
        toast.error('Errore durante il salvataggio');
      }
    } finally {
      toast.dismiss(loadingToast);
      setSavingDDT(false);
    }
  };

  const closeModal = () => {
    setShowNuovaBolla(false);
    setStep(1);
    setSelectedOrdine(null);
    setSelectedFile(null);
    setPreviewUrl(null);
    setImageBase64ForDB(null);
    setAnalisiResult(null);
    setConfronto(null);
    setProdottiVerifica([]); // Reset prodotti verifica
  };

  // Funzioni per DDT Aperto
  const apriDDT = async (ddt) => {
    setDdtAperto(ddt);
    setActionMenuOpen(null);
    setConfrontoPrezzi(null);
    
    // Carica i dati completi (prodotti) solo al click - la lista è leggera
    let full = ddt;
    if (ddt.id && (!ddt.prodotti || ddt.prodotti.length === 0)) {
      try {
        const detRes = await axios.get(`${API}/gestione/ddt/${ddt.id}`, {
          headers: getApiHeaders()
        });
        if (detRes.data) {
          full = { ...ddt, ...detRes.data };
          setDdtAperto(full);
        }
      } catch (err) {
        console.log('Dettaglio DDT non disponibile, uso dati lista');
        toast.error('Impossibile caricare i prodotti della bolla, riprova tra qualche secondo');
      }
    }
    
    setDdtConforme(full.conforme !== false);
    const prodottiConStati = (full.prodotti || []).map((p, index) => ({
      ...p,
      id: p.id || `prod_${index}`,
      arrivato: p.arrivato !== false,
      non_conforme: p.non_conforme || false,
      accettato: p.accettato !== false,
      temp_trasporto: p.temp_trasporto || null
    }));
    setProdottiDDT(prodottiConStati);
    
    // Load confronto prezzi
    if (full.id) {
      loadConfrontoPrezzi(full.id);
      
      // Carica immagine separatamente (lazy loading per performance)
      try {
        const imgRes = await axios.get(`${API}/gestione/ddt/${full.id}/immagine`, {
          headers: getApiHeaders()
        });
        if (imgRes.data && (imgRes.data.immagine_url || imgRes.data.immagine_base64)) {
          setDdtAperto(prev => prev ? {...prev, immagine_url: imgRes.data.immagine_url || imgRes.data.immagine_base64} : prev);
        }
      } catch (err) {
        console.log('Nessuna immagine per questo DDT');
      }
    }
  };

  const mostraStoricoProdotto = async (prodotto) => {
    if (!prodotto.confronto_prezzo || !prodotto.confronto_prezzo.storico) {
      toast.error('Nessuno storico disponibile per questo prodotto');
      return;
    }
    
    setProdottoSelezionato(prodotto);
    setStoricoAcquisti(prodotto.confronto_prezzo.storico.slice(0, 5)); // Ultimi 5
    setShowStoricoModal(true);
  };

  const mostraStoricoConfronto = (confronto) => {
    const storico = (confronto?.storico || []).slice(0, 5).map(s => ({
      data: s.data,
      fornitore: s.fornitore,
      descrizione: s.descrizione,
      prezzo: s.prezzo_normalizzato ?? s.prezzo ?? s.prezzo_unitario ?? 0,
      numero_fattura: s.numero,
      tipo: 'fattura'
    }));
    if (!storico.length) {
      toast.error('Nessuno storico disponibile per questo prodotto');
      return;
    }
    setProdottoSelezionato({
      nome: confronto.prodotto,
      confronto_prezzo: {
        numero_acquisti: confronto.num_acquisti_storici,
        prezzo_medio: confronto.prezzo_medio
      }
    });
    setStoricoAcquisti(storico);
    setShowStoricoModal(true);
  };

  const chiudiStoricoModal = () => {
    setShowStoricoModal(false);
    setProdottoSelezionato(null);
    setStoricoAcquisti([]);
  };

  const chiudiDDTAperto = () => {
    setDdtAperto(null);
    setProdottiDDT([]);
    setConfrontoPrezzi(null);
    setShowInfoGenerali(false);
    setShowAddProduct(false);
    setEditingProduct(null);
  };

  const toggleProdottoStato = (prodIndex, campo) => {
    setProdottiDDT(prev => prev.map((p, i) => 
      i === prodIndex ? { ...p, [campo]: !p[campo] } : p
    ));
  };

  const updateProdotto = (prodIndex, campo, valore) => {
    setProdottiDDT(prev => prev.map((p, i) => 
      i === prodIndex ? { ...p, [campo]: valore } : p
    ));
  };

  const eliminaProdotto = (prodIndex) => {
    if (!window.confirm('Eliminare questo prodotto?')) return;
    setProdottiDDT(prev => prev.filter((_, i) => i !== prodIndex));
    toast.success('Prodotto rimosso');
  };

  const aggiungiProdotto = () => {
    if (!newProduct.nome || !newProduct.quantita) {
      toast.error('Inserisci nome e quantità');
      return;
    }
    
    const nuovoProdotto = {
      id: `prod_new_${Date.now()}`,
      nome: newProduct.nome,
      quantita: parseFloat(newProduct.quantita) || 0,
      unita_misura: newProduct.unita_misura || 'kg',
      prezzo_unitario: parseFloat(newProduct.prezzo_unitario) || 0,
      lotto: newProduct.lotto || null,
      scadenza: newProduct.scadenza || null,
      arrivato: true,
      non_conforme: false,
      accettato: true
    };
    
    setProdottiDDT(prev => [...prev, nuovoProdotto]);
    setNewProduct({ nome: '', quantita: '', unita_misura: 'kg', prezzo_unitario: '', lotto: '', scadenza: '' });
    setShowAddProduct(false);
    toast.success('Prodotto aggiunto');
  };

  const salvaModificheProdotto = () => {
    if (!editingProduct) return;
    
    setProdottiDDT(prev => prev.map((p, i) => 
      i === editingProduct.index ? {
        ...p,
        nome: editingProduct.nome,
        quantita: parseFloat(editingProduct.quantita) || p.quantita,
        unita_misura: editingProduct.unita_misura || p.unita_misura,
        prezzo_unitario: parseFloat(editingProduct.prezzo_unitario) || p.prezzo_unitario,
        lotto: editingProduct.lotto,
        scadenza: editingProduct.scadenza,
        temp_trasporto: editingProduct.temp_trasporto
      } : p
    ));
    
    setEditingProduct(null);
    toast.success('Prodotto aggiornato');
  };

  const salvaDDTAperto = async () => {
    if (!ddtAperto) return;
    
    try {
      setSavingDDT(true);
      // Cerca prima i dati tenant, poi quelli standard
      const token = localStorage.getItem('tenant_token') || localStorage.getItem('token');
      const userStr = localStorage.getItem('tenant_user') || localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : {};
      const tenantDb = user.tenants && user.tenants[0] ? user.tenants[0].database_name : null;
      
      const headers = getApiHeaders();
      if (tenantDb) {
        headers['X-Tenant-DB'] = tenantDb.replace('tenant_', '');
      }
      
      // Trova i prodotti segnati come "reso"
      const prodottiReso = prodottiDDT.filter(p => p.stato_consegna === 'reso' || p.non_conforme === true);
      
      await axios.put(`${API}/gestione/ddt/${ddtAperto.id}`, {
        conforme: ddtConforme,
        prodotti: prodottiDDT
      }, {
        headers
      });
      
      // Se ci sono prodotti reso, creali automaticamente nella sezione "Resi"
      if (prodottiReso.length > 0) {
        for (const prodotto of prodottiReso) {
          try {
            const resoData = {
              prodotto_nome: prodotto.nome,
              quantita: prodotto.quantita || 1,
              unita_misura: prodotto.unita_misura || 'pz',
              prezzo_unitario: prodotto.prezzo_unitario || 0,
              valore_totale: (prodotto.quantita || 1) * (prodotto.prezzo_unitario || 0),
              motivo: prodotto.non_conforme ? 'Non conforme' : 'Reso da DDT',
              fornitore: ddtAperto.fornitore || '',
              ddt_riferimento: ddtAperto.numero || ddtAperto.id,
              data_reso: new Date().toISOString().split('T')[0],
              stato: 'in_attesa',
              note: `Creato automaticamente da DDT ${ddtAperto.numero}. ${prodotto.note || ''}`
            };
            
            await axios.post(`${API}/gestione/resi-fornitore`, resoData, {
              headers
            });
          } catch (error) {
            console.error(`Errore creazione reso per ${prodotto.nome}:`, error);
          }
        }
        
        toast.success(`DDT aggiornato. ${prodottiReso.length} prodotti reso aggiunti automaticamente.`);
      } else {
        toast.success('DDT aggiornato con successo');
      }
      
      loadDDT();
      chiudiDDTAperto();
    } catch (error) {
      console.error('Errore aggiornamento DDT:', error);
      toast.error('Errore durante l\'aggiornamento');
    } finally {
      setSavingDDT(false);
    }
  };

  const eliminaDDT = async (ddtId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo DDT?')) return;
    
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/gestione/ddt/${ddtId}`, {
        headers: getApiHeaders()
      });
      toast.success('DDT eliminato');
      loadDDT();
    } catch (error) {
      console.error('Errore eliminazione:', error);
      toast.error('Errore durante l\'eliminazione');
    }
  };

  const condividiDDT = () => {
    if (!ddtAperto) return;
    
    const totaleCalcolato = prodottiDDT.reduce((sum, p) => sum + (p.quantita * p.prezzo_unitario || 0), 0);
    const testo = `DDT #${ddtAperto.numero} - ${ddtAperto.fornitore}\n` +
      `Data: ${formatDate(ddtAperto.data_ddt)}\n` +
      `Totale: ${formatCurrency(totaleCalcolato)}\n` +
      `Prodotti: ${prodottiDDT.length}`;
    
    if (navigator.share) {
      navigator.share({ title: `DDT #${ddtAperto.numero}`, text: testo });
    } else {
      navigator.clipboard.writeText(testo);
      toast.success('Dettagli copiati negli appunti');
    }
  };

  // Helper functions
  const getStatusBadge = (status) => {
    const statusConfig = {
      'completato': { color: 'bg-green-100 text-green-800', icon: CheckCircle, label: 'Verificato' },
      'confermato': { color: 'bg-green-100 text-green-800', icon: CheckCircle, label: 'Confermato' },
      'in_attesa': { color: 'bg-yellow-100 text-yellow-800', icon: Clock, label: 'In Attesa' },
      'bozza': { color: 'bg-gray-100 text-gray-800', icon: AlertCircle, label: 'Bozza' },
      'errore': { color: 'bg-red-100 text-red-800', icon: AlertCircle, label: 'Errore' }
    };
    const config = statusConfig[status] || statusConfig['bozza'];
    const Icon = config.icon;
    return (
      <Badge className={`${config.color} flex items-center gap-1`}>
        <Icon className="h-3 w-3" />
        <span className="hidden sm:inline">{config.label}</span>
      </Badge>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      // Gestisci formato italiano DD/MM/YYYY
      if (typeof dateStr === 'string' && dateStr.includes('/')) {
        const parts = dateStr.split('/');
        if (parts.length === 3) {
          // Riordina da DD/MM/YYYY a YYYY-MM-DD per JavaScript
          const [day, month, year] = parts;
          if (day && month && year) {
            const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            if (!isNaN(date.getTime())) {
              return date.toLocaleDateString('it-IT');
            }
          }
        }
      }
      // Prova parsing diretto per altri formati (ISO, etc.)
      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('it-IT');
      }
      return dateStr; // Ritorna il valore originale se non riesce a parsare
    } catch {
      return dateStr;
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount || 0);
  };

  const calcolaTotalePrevisto = (ordine) => {
    if (ordine.totale_previsto) return ordine.totale_previsto;
    if (ordine.totale && ordine.totale > 0) return ordine.totale;
    const prodotti = ordine.prodotti_attesi || ordine.prodotti || [];
    return prodotti.reduce((sum, p) => {
      const qty = parseFloat(p.quantita) || 0;
      const price = parseFloat(p.prezzo_stimato || p.prezzo_unitario) || 0;
      return sum + (qty * price);
    }, 0);
  };

  const getTrendIcon = (trend) => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4 text-red-500" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4 text-green-500" />;
    return <Minus className="h-4 w-4 text-gray-400" />;
  };

  const getConfrontoProdotto = (nomeProdotto) => {
    if (!confrontoPrezzi) return null;
    return confrontoPrezzi.find(c => 
      c.prodotto?.toLowerCase() === nomeProdotto?.toLowerCase() ||
      c.prodotto?.toLowerCase().includes(nomeProdotto?.toLowerCase()) ||
      nomeProdotto?.toLowerCase().includes(c.prodotto?.toLowerCase())
    );
  };

  // ============ RENDER: DDT APERTO (VISTA DETTAGLIATA) ============
  const storicoModal = showStoricoModal && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[150]" data-testid="storico-acquisti-modal">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">
            Storico Acquisti - {prodottoSelezionato?.nome}
          </h3>
          <button
            onClick={chiudiStoricoModal}
            className="text-gray-500 hover:text-gray-700"
            data-testid="chiudi-storico-x"
          >
            ✕
          </button>
        </div>
        
        <div className="space-y-3">
          {storicoAcquisti.length > 0 ? (
            storicoAcquisti.map((acquisto, index) => (
              <div key={index} className="bg-gray-50 p-3 rounded-lg" data-testid={`storico-riga-${index}`}>
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-700">
                    📅 {formatDate(acquisto.data_fattura || acquisto.data)}
                  </span>
                  <span className="font-semibold text-green-600">
                    €{(acquisto.prezzo || 0).toFixed(2)}
                  </span>
                </div>
                <div className="text-sm text-gray-600 mt-1 flex items-center justify-between">
                  <div>
                    <span className="text-blue-600 font-medium">{acquisto.fornitore}</span>
                    {acquisto.numero_fattura && (
                      <span className="ml-2 text-gray-500">• FT #{acquisto.numero_fattura}</span>
                    )}
                  </div>
                  <span className="text-xs px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full">
                    {acquisto.tipo === 'fattura' ? 'Fattura' : 'DDT'}
                  </span>
                </div>
                {acquisto.descrizione && acquisto.descrizione !== prodottoSelezionato?.nome && (
                  <div className="text-xs text-gray-500 mt-1">
                    Nome FT: {acquisto.descrizione}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="text-gray-500 text-center py-4">
              Nessuno storico disponibile
            </div>
          )}
        </div>
        
        {prodottoSelezionato?.confronto_prezzo && (
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <h4 className="font-medium text-blue-800">Riepilogo</h4>
            <div className="grid grid-cols-2 gap-4 mt-2 text-sm">
              <div>
                <span className="text-blue-600">Acquisti totali:</span>
                <span className="ml-2 font-medium">{prodottoSelezionato.confronto_prezzo.numero_acquisti}</span>
              </div>
              <div>
                <span className="text-blue-600">Prezzo medio:</span>
                <span className="ml-2 font-medium">€{prodottoSelezionato.confronto_prezzo.prezzo_medio}</span>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex justify-end mt-6">
          <button
            onClick={chiudiStoricoModal}
            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
            data-testid="chiudi-storico-btn"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );

  if (ddtAperto) {
    return (
      <div className="min-h-screen bg-transparent lg:bg-gray-50">
        {/* Header Mobile - Dark */}
        <div className="lg:hidden sticky top-0 z-10 bg-black/60 backdrop-blur-md border-b border-slate-700/50">
          <div className="px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <button onClick={chiudiDDTAperto} className="p-2 bg-black/40 backdrop-blur-md rounded-xl">
                  <ArrowLeft className="h-5 w-5 text-white" />
                </button>
                <div>
                  <h1 className="text-lg font-bold text-white">DDT #{ddtAperto.numero}</h1>
                  <p className="text-xs text-purple-400">{ddtAperto.fornitore}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => setShowInfoGenerali(true)} className="p-2 bg-black/40 backdrop-blur-md rounded-xl">
                  <Info className="h-4 w-4 text-white" />
                </button>
                <button onClick={condividiDDT} className="p-2 bg-black/40 backdrop-blur-md rounded-xl">
                  <Share2 className="h-4 w-4 text-white" />
                </button>
                {getStatusBadge(ddtAperto.status)}
              </div>
            </div>
          </div>
        </div>

        {/* Header Desktop */}
        <div className="hidden lg:block bg-white border-b sticky top-0 z-10">
          <div className="w-full px-3 sm:px-4 py-2 sm:py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 sm:gap-3">
                <Button variant="ghost" size="sm" onClick={chiudiDDTAperto} className="p-2">
                  <ArrowLeft className="h-5 w-5" />
                </Button>
                <div>
                  <h1 className="text-lg sm:text-xl font-bold">DDT #{ddtAperto.numero}</h1>
                  <p className="text-xs sm:text-sm text-gray-500">{ddtAperto.fornitore}</p>
                </div>
              </div>
              
              {/* Desktop buttons */}
              <div className="hidden sm:flex items-center gap-2">
                <Button variant="outline" size="sm" onClick={() => setShowInfoGenerali(true)}>
                  <Info className="h-4 w-4 mr-1" />
                  Info generali
                </Button>
                <Button variant="outline" size="sm" onClick={() => setShowAddProduct(true)} className="text-purple-600 border-purple-600">
                  <Plus className="h-4 w-4 mr-1" />
                  Aggiungi prodotto
                </Button>
                <Button variant="outline" size="sm" onClick={condividiDDT}>
                  <Share2 className="h-4 w-4 mr-1" />
                  Condividi
                </Button>
              </div>
              
              {/* Mobile menu */}
              <div className="sm:hidden flex items-center gap-1">
                <Button variant="ghost" size="sm" onClick={() => setShowAddProduct(true)} className="p-2 text-purple-600">
                  <Plus className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="sm" onClick={condividiDDT} className="p-2">
                  <Share2 className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="sm" onClick={() => setShowInfoGenerali(true)} className="p-2">
                  <Info className="h-5 w-5" />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="w-full px-4 lg:px-6 py-4 lg:py-6 space-y-4 lg:space-y-6 pb-32 lg:max-w-7xl lg:mx-auto">
          {/* Info Cards - Modern Design */}
          <div className="hidden lg:grid lg:grid-cols-4 gap-4">
            {/* Card Fornitore */}
            <div className="bg-gradient-to-br from-purple-500 to-purple-700 rounded-2xl p-5 text-white shadow-lg">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-white/20 rounded-xl">
                  <Building className="h-5 w-5" />
                </div>
                <span className="text-sm text-purple-200">Fornitore</span>
              </div>
              <p className="font-bold text-lg truncate">{ddtAperto.fornitore}</p>
            </div>
            
            {/* Card Data */}
            <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl p-5 text-white shadow-lg">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-white/20 rounded-xl">
                  <Calendar className="h-5 w-5" />
                </div>
                <span className="text-sm text-blue-200">Data DDT</span>
              </div>
              <p className="font-bold text-lg">{formatDate(ddtAperto.data_ddt)}</p>
            </div>
            
            {/* Card Totale */}
            <div className="bg-gradient-to-br from-green-500 to-green-700 rounded-2xl p-5 text-white shadow-lg">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-white/20 rounded-xl">
                  <DollarSign className="h-5 w-5" />
                </div>
                <span className="text-sm text-green-200">Totale DDT</span>
              </div>
              <p className="font-bold text-lg">
                {formatCurrency(prodottiDDT.reduce((sum, p) => sum + (p.quantita * p.prezzo_unitario || 0), 0))}
              </p>
            </div>
            
            {/* Card Stato */}
            <div className={`rounded-2xl p-5 text-white shadow-lg ${ddtConforme ? 'bg-gradient-to-br from-emerald-500 to-emerald-700' : 'bg-gradient-to-br from-orange-500 to-orange-700'}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-white/20 rounded-xl">
                  {ddtConforme ? <CheckCircle className="h-5 w-5" /> : <AlertCircle className="h-5 w-5" />}
                </div>
                <span className="text-sm opacity-80">Stato DDT</span>
              </div>
              <div className="flex items-center justify-between">
                <p className="font-bold text-lg">{ddtConforme ? 'Conforme' : 'Da verificare'}</p>
                <div 
                  onClick={() => setDdtConforme(!ddtConforme)}
                  className={`w-14 h-7 rounded-full cursor-pointer transition-colors ${ddtConforme ? 'bg-white/30' : 'bg-white/20'}`}
                >
                  <div className={`w-6 h-6 rounded-full bg-white mt-0.5 transition-transform shadow-md ${ddtConforme ? 'translate-x-7' : 'translate-x-1'}`} />
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Info Box */}
          <div className="lg:hidden bg-black/40 backdrop-blur-md rounded-xl border border-slate-700 p-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
              {/* Fornitore */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-slate-400">Fornitore</p>
                  <p className="font-semibold text-white text-sm">{ddtAperto.fornitore}</p>
                </div>
              </div>
              
              {/* Data DDT */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-slate-400">Data DDT</p>
                  <p className="font-semibold text-white text-sm">{formatDate(ddtAperto.data_ddt)}</p>
                </div>
              </div>
              
              {/* DDT Conforme Toggle */}
              <div className="flex items-center justify-between">
                <p className="text-xs text-slate-400">DDT Conforme</p>
                <div 
                  onClick={() => setDdtConforme(!ddtConforme)}
                  className={`w-12 h-6 rounded-full cursor-pointer transition-colors ${ddtConforme ? 'bg-green-500' : 'bg-slate-600'}`}
                >
                  <div className={`w-5 h-5 rounded-full bg-white mt-0.5 transition-transform ${ddtConforme ? 'translate-x-6' : 'translate-x-1'}`} />
                </div>
              </div>
            </div>
          </div>
          
          {/* Variazioni Prezzo Alert */}
          {loadingConfronto ? (
            <div className="bg-white lg:bg-slate-50 rounded-xl p-4 flex items-center gap-3 border border-gray-200">
              <Loader2 className="h-5 w-5 animate-spin text-purple-500" />
              <span className="text-gray-600">Analisi prezzi in corso...</span>
            </div>
          ) : confrontoPrezzi && confrontoPrezzi.filter(c => !c.primo_acquisto && c.variazione_perc && Math.abs(c.variazione_perc) >= 2).length > 0 && (
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-4 border border-amber-200">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-amber-100 rounded-xl">
                  <TrendingUp className="h-5 w-5 text-amber-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800">Variazioni Prezzo Rilevate</h3>
                  <p className="text-sm text-amber-600">Confronto per unità ({confrontoPrezzi[0]?.unita_misura || '€/unità'})</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {confrontoPrezzi.filter(c => !c.primo_acquisto && c.variazione_perc && Math.abs(c.variazione_perc) >= 2).slice(0, 5).map((c, i) => (
                  <div 
                    key={i} 
                    onClick={() => mostraStoricoConfronto(c)}
                    data-testid="chip-variazione-banner"
                    className={`px-3 py-2 rounded-xl text-sm font-medium flex items-center gap-2 cursor-pointer hover:opacity-80 ${
                      c.variazione_perc > 0 
                        ? 'bg-red-100 text-red-700 border border-red-200' 
                        : 'bg-green-100 text-green-700 border border-green-200'
                    }`}
                    title={`${c.unita_misura}: Attuale €${c.prezzo_attuale_normalizzato || c.prezzo_attuale} vs prezzo abituale €${c.prezzo_mediano ?? c.prezzo_precedente} · ultimo €${c.prezzo_precedente}${dataBreve(c.data_prezzo_precedente) ? ` del ${dataBreve(c.data_prezzo_precedente)}` : ''} · clicca per lo storico`}
                  >
                    {c.variazione_perc > 0 ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
                    <span className="truncate max-w-[120px]">{c.prodotto}</span>
                    <span className="font-bold">{c.variazione_perc > 0 ? '+' : ''}{c.variazione_perc}%</span>
                    {c.fornitore_prezzo_migliore && c.prezzo_migliore < (c.prezzo_attuale_normalizzato || c.prezzo_attuale) && (
                      <span className="text-xs bg-blue-100 text-blue-700 px-1 rounded" title={`Prezzo migliore da ${c.fornitore_prezzo_migliore}`}>💡</span>
                    )}
                  </div>
                ))}
              </div>
              {/* Info sui primi acquisti */}
              {confrontoPrezzi.filter(c => c.primo_acquisto).length > 0 && (
                <p className="mt-2 text-xs text-gray-500">
                  ℹ️ {confrontoPrezzi.filter(c => c.primo_acquisto).length} prodotti senza storico (primo acquisto)
                </p>
              )}
            </div>
          )}

          {/* Tabella Prodotti Desktop - Modern */}
          <div className="hidden lg:block bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-100 rounded-xl">
                  <Package className="h-5 w-5 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Prodotti</h3>
                  <p className="text-sm text-gray-500">{prodottiDDT.length} articoli nel documento</p>
                </div>
              </div>
              <Button variant="outline" size="sm" onClick={() => setShowAddProduct(true)} className="text-purple-600 border-purple-300 hover:bg-purple-50">
                <Plus className="h-4 w-4 mr-2" />
                Aggiungi
              </Button>
            </div>
            
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50/80">
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Prodotto</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Quantità</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Prezzo</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Var. %</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Lotto</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Scadenza</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Ricevuto</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">NC</th>
                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider w-24">Azioni</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {prodottiDDT.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="px-6 py-12 text-center">
                        <Package className="h-12 w-12 mx-auto mb-3 text-gray-300" />
                        <p className="text-gray-500">Nessun prodotto nel DDT</p>
                        <Button variant="outline" size="sm" className="mt-3" onClick={() => setShowAddProduct(true)}>
                          <Plus className="h-4 w-4 mr-2" />
                          Aggiungi prodotto
                        </Button>
                      </td>
                    </tr>
                  ) : (
                    prodottiDDT.map((prodotto, index) => {
                      const confronto = getConfrontoProdotto(prodotto.nome);
                      return (
                        <tr key={prodotto.id || index} className={`hover:bg-gray-50/50 transition-colors ${prodotto.non_conforme ? 'bg-red-50/50' : ''}`}>
                          <td className="px-6 py-4">
                            <div>
                              <p className="font-medium text-gray-900">{prodotto.nome}</p>
                              {prodotto.codice_prodotto && (
                                <p className="text-xs text-gray-500 mt-0.5">Cod: {prodotto.codice_prodotto}</p>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-4 text-center">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-700">
                              {prodotto.quantita} {prodotto.unita_misura}
                            </span>
                          </td>
                          <td className="px-4 py-4 text-center">
                            <span className="font-semibold text-gray-900">{formatCurrency(prodotto.prezzo_unitario)}</span>
                          </td>
                          <td className="px-4 py-4 text-center">
                            {confronto && confronto.primo_acquisto ? (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">🆕 Primo</span>
                            ) : confronto && confronto.variazione_perc !== null && confronto.variazione_perc !== undefined ? (
                              Math.abs(confronto.variazione_perc) >= 2 ? (
                                <span onClick={() => mostraStoricoConfronto(confronto)} data-testid="badge-variazione-desktop" className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold cursor-pointer hover:opacity-80 ${
                                  confronto.variazione_perc > 0 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                                }`} title={`vs prezzo abituale €${confronto.prezzo_mediano ?? confronto.prezzo_precedente} · ultimo €${confronto.prezzo_precedente}${dataBreve(confronto.data_prezzo_precedente) ? ` del ${dataBreve(confronto.data_prezzo_precedente)}` : ''} · media €${confronto.prezzo_medio} · clicca per lo storico`}>
                                  {confronto.variazione_perc > 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                                  {confronto.variazione_perc > 0 ? '+' : ''}{confronto.variazione_perc}%
                                </span>
                              ) : (
                                <span onClick={() => mostraStoricoConfronto(confronto)} data-testid="badge-stabile-desktop" className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600 cursor-pointer hover:opacity-80" title={`Prezzo abituale €${confronto.prezzo_mediano ?? confronto.prezzo_precedente} · ultimo €${confronto.prezzo_precedente}${dataBreve(confronto.data_prezzo_precedente) ? ` del ${dataBreve(confronto.data_prezzo_precedente)}` : ''} · clicca per lo storico`}>✓ stabile</span>
                              )
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </td>
                          <td className="px-4 py-4 text-center text-sm text-gray-600">{prodotto.lotto || '-'}</td>
                          <td className="px-4 py-4 text-center text-sm text-gray-600">{prodotto.scadenza || '-'}</td>
                          <td className="px-4 py-4 text-center">
                            <button 
                              onClick={() => toggleProdottoStato(index, 'arrivato')}
                              className={`w-10 h-6 rounded-full transition-all ${prodotto.arrivato ? 'bg-green-500' : 'bg-gray-200'}`}
                            >
                              <div className={`w-5 h-5 rounded-full bg-white shadow-sm transition-transform ${prodotto.arrivato ? 'translate-x-4' : 'translate-x-0.5'}`} />
                            </button>
                          </td>
                          <td className="px-4 py-4 text-center">
                            <button 
                              onClick={() => toggleProdottoStato(index, 'non_conforme')}
                              className={`w-10 h-6 rounded-full transition-all ${prodotto.non_conforme ? 'bg-red-500' : 'bg-gray-200'}`}
                            >
                              <div className={`w-5 h-5 rounded-full bg-white shadow-sm transition-transform ${prodotto.non_conforme ? 'translate-x-4' : 'translate-x-0.5'}`} />
                            </button>
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center justify-center gap-1">
                              <button 
                                onClick={() => setEditingProduct({ ...prodotto, index })}
                                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                              >
                                <Pencil className="h-4 w-4 text-gray-400 hover:text-gray-600" />
                              </button>
                              <button 
                                onClick={() => eliminaProdotto(index)}
                                className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                              >
                                <Trash2 className="h-4 w-4 text-gray-400 hover:text-red-500" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Product Cards */}
          <div className="lg:hidden space-y-3">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-semibold text-white text-sm">Prodotti ({prodottiDDT.length})</h3>
              <button 
                onClick={() => setShowAddProduct(true)}
                className="px-3 py-1.5 bg-purple-600 text-white text-xs rounded-lg flex items-center gap-1"
              >
                <Plus className="h-3 w-3" />
                Aggiungi
              </button>
            </div>
            {prodottiDDT.length === 0 ? (
              <div className="bg-black/40 backdrop-blur-md rounded-xl p-6 text-center border border-slate-700">
                <Package className="h-10 w-10 mx-auto mb-3 text-slate-500" />
                <p className="text-slate-400 text-sm">Nessun prodotto</p>
              </div>
            ) : (
              prodottiDDT.map((prodotto, index) => {
                const confronto = getConfrontoProdotto(prodotto.nome);
                return (
                  <div key={prodotto.id || index} className="bg-black/40 backdrop-blur-md rounded-xl p-4 border border-slate-700">
                    <div className="flex items-start justify-between mb-2">
                      <div className="flex-1">
                        <p className="font-medium text-white text-sm">{prodotto.nome}</p>
                        <p className="text-xs text-slate-400">
                          {prodotto.quantita} {prodotto.unita_misura}
                          {prodotto.lotto && ` • Lotto: ${prodotto.lotto}`}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-green-400">{formatCurrency(prodotto.totale || (prodotto.quantita * prodotto.prezzo_unitario))}</p>
                        <p className="text-xs text-slate-400">{formatCurrency(prodotto.prezzo_unitario)}/u</p>
                      </div>
                    </div>
                    
                    {/* Confronto prezzo: SEMPRE visibile quando c'è storico */}
                    {confronto && confronto.possibile_inversione_qta_prezzo && (
                      <div className="p-2 rounded-lg text-xs mb-2 bg-amber-500/20 text-amber-400" data-testid="badge-inversione-mobile">
                        ⚠️ Quantità e prezzo forse invertiti: verifica la riga
                      </div>
                    )}
                    {confronto && confronto.primo_acquisto && (
                      <div className="p-2 rounded-lg text-xs mb-3 bg-blue-500/20 text-blue-400">
                        🆕 Primo acquisto: nessuno storico da confrontare
                      </div>
                    )}
                    {confronto && !confronto.primo_acquisto && confronto.variazione_perc !== null && confronto.variazione_perc !== undefined && (
                      Math.abs(confronto.variazione_perc) >= 2 ? (
                        <div onClick={() => mostraStoricoConfronto(confronto)} data-testid="badge-variazione-mobile" className={`p-2 rounded-lg text-xs mb-3 cursor-pointer active:opacity-70 ${
                          confronto.variazione_perc > 0 
                            ? 'bg-red-500/20 text-red-400' 
                            : 'bg-green-500/20 text-green-400'
                        }`}>
                          {confronto.variazione_perc > 0 ? <TrendingUp className="h-3 w-3 inline mr-1" /> : <TrendingDown className="h-3 w-3 inline mr-1" />}
                          {confronto.variazione_perc > 0 ? '+' : ''}{confronto.variazione_perc}% vs prezzo abituale (€{confronto.prezzo_mediano ?? confronto.prezzo_precedente}) · ultimo €{confronto.prezzo_precedente}{dataBreve(confronto.data_prezzo_precedente) ? ` del ${dataBreve(confronto.data_prezzo_precedente)}` : ''} · tocca per lo storico
                        </div>
                      ) : (
                        <div onClick={() => mostraStoricoConfronto(confronto)} className="p-2 rounded-lg text-xs mb-3 bg-slate-700/50 text-slate-300 cursor-pointer active:opacity-70" data-testid="badge-prezzo-in-linea">
                          ✓ In linea con lo storico · ultimo €{confronto.prezzo_precedente}{dataBreve(confronto.data_prezzo_precedente) ? ` del ${dataBreve(confronto.data_prezzo_precedente)}` : ''}{confronto.num_acquisti_storici ? ` (${confronto.num_acquisti_storici} acquisti)` : ''} · tocca per lo storico
                        </div>
                      )
                    )}
                    
                    {/* Actions */}
                    <div className="flex items-center justify-between pt-2 border-t border-slate-700/50">
                      <div className="flex items-center gap-3">
                        <label className="flex items-center gap-2 text-xs text-slate-400">
                          <input 
                            type="checkbox" 
                            checked={prodotto.arrivato !== false}
                            onChange={() => toggleProdottoStato(index, 'arrivato')}
                            className="rounded border-slate-600 bg-slate-800 text-green-500"
                          />
                          Ricevuto
                        </label>
                        <label className="flex items-center gap-2 text-xs text-slate-400">
                          <input 
                            type="checkbox" 
                            checked={prodotto.non_conforme === true}
                            onChange={() => toggleProdottoStato(index, 'non_conforme')}
                            className="rounded border-slate-600 bg-slate-800 text-red-500"
                          />
                          NC
                        </label>
                      </div>
                      <div className="flex items-center gap-1">
                        <button 
                          onClick={() => setEditingProduct({ ...prodotto, index })}
                          className="p-2 hover:bg-slate-700 rounded-lg"
                        >
                          <Pencil className="h-4 w-4 text-slate-400" />
                        </button>
                        <button 
                          onClick={() => eliminaProdotto(index)}
                          className="p-2 hover:bg-red-900/30 rounded-lg"
                        >
                          <Trash2 className="h-4 w-4 text-red-400" />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Footer fisso - Dark Mobile / Light Desktop - SOPRA bottom nav */}
        <div className="fixed lg:bottom-0 left-0 right-0 safe-footer bg-black/60 backdrop-blur-md lg:bg-white border-t border-slate-700 lg:border-gray-200 shadow-lg z-20">
          <div className="w-full px-4 py-3">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-400 lg:text-gray-500">Totale DDT</p>
                <p className="text-xl font-bold text-green-400 lg:text-gray-900">
                  {formatCurrency(prodottiDDT.reduce((sum, p) => sum + (p.quantita * p.prezzo_unitario || 0), 0))}
                </p>
              </div>
              <div className="flex gap-2">
                <button 
                  onClick={chiudiDDTAperto} 
                  className="px-4 py-2.5 bg-black/40 backdrop-blur-md lg:bg-gray-100 hover:bg-slate-700 lg:hover:bg-gray-200 text-white lg:text-gray-700 rounded-xl font-medium text-sm border border-slate-700 lg:border-transparent"
                >
                  Annulla
                </button>
                <button 
                  onClick={salvaDDTAperto} 
                  disabled={savingDDT}
                  className="px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-xl font-medium text-sm flex items-center gap-2 disabled:opacity-50"
                >
                  {savingDDT ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                  ) : (
                    <>
                      <Save className="h-4 w-4" />
                      Salva
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Info Generali - Responsive Dark Theme */}
        {showInfoGenerali && (
          <div className="fixed inset-0 bg-black/60 lg:bg-black/50 flex items-end lg:items-center justify-center z-[60]">
            <div className="bg-black/60 backdrop-blur-md lg:bg-white rounded-t-3xl lg:rounded-xl shadow-xl w-full lg:max-w-md max-h-[85vh] lg:max-h-none overflow-hidden">
              {/* Header */}
              <div className="flex items-center justify-between p-4 border-b border-slate-700 lg:border-gray-200">
                <h3 className="font-bold text-lg text-white lg:text-gray-900">Info Generali DDT</h3>
                <button 
                  onClick={() => setShowInfoGenerali(false)}
                  className="p-2 bg-black/40 backdrop-blur-md lg:bg-gray-100 rounded-xl"
                >
                  <X className="h-5 w-5 text-white lg:text-gray-600" />
                </button>
              </div>
              
              {/* Content */}
              <div className="p-4 space-y-4 overflow-y-auto max-h-[60vh] lg:max-h-none">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Numero DDT</label>
                    <p className="font-semibold text-white lg:text-gray-900">#{ddtAperto.numero}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Stato</label>
                    <div className="mt-1">{getStatusBadge(ddtAperto.status)}</div>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Fornitore</label>
                    <p className="font-semibold text-white lg:text-gray-900 text-sm">{ddtAperto.fornitore}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Data DDT</label>
                    <p className="font-semibold text-white lg:text-gray-900">{formatDate(ddtAperto.data_ddt)}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Data Creazione</label>
                    <p className="font-semibold text-white lg:text-gray-900">{formatDate(ddtAperto.data_creazione)}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Creato da</label>
                    <p className="font-semibold text-white lg:text-gray-900">{ddtAperto.creato_da || '-'}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">N° Prodotti</label>
                    <p className="font-semibold text-white lg:text-gray-900">{prodottiDDT.length}</p>
                  </div>
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Totale</label>
                    <p className="font-semibold text-green-400 lg:text-green-600">
                      {formatCurrency(prodottiDDT.reduce((sum, p) => sum + (p.quantita * p.prezzo_unitario || 0), 0))}
                    </p>
                  </div>
                </div>
                {ddtAperto.note && (
                  <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-xl">
                    <label className="text-xs text-slate-400 lg:text-gray-500">Note</label>
                    <p className="text-sm text-white lg:text-gray-700 mt-1">{ddtAperto.note}</p>
                  </div>
                )}
                {ddtAperto.immagine_url && (
                  <button 
                    onClick={() => { setShowInfoGenerali(false); setShowImmagine(ddtAperto.immagine_url); }}
                    className="w-full py-3 px-4 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-medium flex items-center justify-center gap-2"
                  >
                    <Image className="h-4 w-4" />
                    Visualizza Immagine DDT
                  </button>
                )}
              </div>
              
              {/* Footer */}
              <div className="p-4 border-t border-slate-700 lg:border-gray-200">
                <button 
                  onClick={() => setShowInfoGenerali(false)}
                  className="w-full py-3 bg-black/40 backdrop-blur-md lg:bg-gray-100 hover:bg-slate-700 lg:hover:bg-gray-200 text-white lg:text-gray-700 rounded-xl font-medium"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Aggiungi Prodotto */}
        {showAddProduct && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
              <div className="flex items-center justify-between p-4 border-b">
                <h3 className="font-bold text-lg">Aggiungi Prodotto</h3>
                <Button variant="ghost" size="sm" onClick={() => setShowAddProduct(false)}>
                  <X className="h-5 w-5" />
                </Button>
              </div>
              <div className="p-4 space-y-4">
                <div>
                  <label className="text-sm text-gray-600">Nome prodotto *</label>
                  <Input 
                    value={newProduct.nome} 
                    onChange={(e) => setNewProduct({...newProduct, nome: e.target.value})}
                    placeholder="Es: Mozzarella di bufala"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm text-gray-600">Quantità *</label>
                    <Input 
                      type="number"
                      value={newProduct.quantita} 
                      onChange={(e) => setNewProduct({...newProduct, quantita: e.target.value})}
                      placeholder="0"
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Unità</label>
                    <select 
                      value={newProduct.unita_misura}
                      onChange={(e) => setNewProduct({...newProduct, unita_misura: e.target.value})}
                      className="w-full border rounded-lg px-3 py-2"
                    >
                      <option value="kg">kg</option>
                      <option value="pz">pz</option>
                      <option value="lt">lt</option>
                      <option value="ct">ct</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Prezzo unitario (€)</label>
                  <Input 
                    type="number"
                    step="0.01"
                    value={newProduct.prezzo_unitario} 
                    onChange={(e) => setNewProduct({...newProduct, prezzo_unitario: e.target.value})}
                    placeholder="0.00"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm text-gray-600">Lotto</label>
                    <Input 
                      value={newProduct.lotto} 
                      onChange={(e) => setNewProduct({...newProduct, lotto: e.target.value})}
                      placeholder="Numero lotto"
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Scadenza</label>
                    <Input 
                      type="date"
                      value={newProduct.scadenza} 
                      onChange={(e) => setNewProduct({...newProduct, scadenza: e.target.value})}
                    />
                  </div>
                </div>
                <Button onClick={aggiungiProdotto} className="w-full bg-purple-600 hover:bg-purple-700">
                  <Plus className="h-4 w-4 mr-2" />
                  Aggiungi Prodotto
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Modifica Prodotto */}
        {editingProduct && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
              <div className="flex items-center justify-between p-4 border-b">
                <h3 className="font-bold text-lg">Modifica Prodotto</h3>
                <Button variant="ghost" size="sm" onClick={() => setEditingProduct(null)}>
                  <X className="h-5 w-5" />
                </Button>
              </div>
              <div className="p-4 space-y-4">
                <div>
                  <label className="text-sm text-gray-600">Nome prodotto</label>
                  <Input 
                    value={editingProduct.nome} 
                    onChange={(e) => setEditingProduct({...editingProduct, nome: e.target.value})}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm text-gray-600">Quantità</label>
                    <Input 
                      type="number"
                      value={editingProduct.quantita} 
                      onChange={(e) => setEditingProduct({...editingProduct, quantita: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Unità</label>
                    <select 
                      value={editingProduct.unita_misura}
                      onChange={(e) => setEditingProduct({...editingProduct, unita_misura: e.target.value})}
                      className="w-full border rounded-lg px-3 py-2"
                    >
                      <option value="kg">kg</option>
                      <option value="pz">pz</option>
                      <option value="lt">lt</option>
                      <option value="ct">ct</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Prezzo unitario (€)</label>
                  <Input 
                    type="number"
                    step="0.01"
                    value={editingProduct.prezzo_unitario} 
                    onChange={(e) => setEditingProduct({...editingProduct, prezzo_unitario: e.target.value})}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm text-gray-600">Lotto</label>
                    <Input 
                      value={editingProduct.lotto || ''} 
                      onChange={(e) => setEditingProduct({...editingProduct, lotto: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-600">Scadenza</label>
                    <Input 
                      type="date"
                      value={editingProduct.scadenza || ''} 
                      onChange={(e) => setEditingProduct({...editingProduct, scadenza: e.target.value})}
                    />
                  </div>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Temperatura trasporto (°C)</label>
                  <Input 
                    type="number"
                    value={editingProduct.temp_trasporto || ''} 
                    onChange={(e) => setEditingProduct({...editingProduct, temp_trasporto: e.target.value})}
                    placeholder="Es: 4"
                  />
                </div>
                <Button onClick={salvaModificheProdotto} className="w-full bg-green-600 hover:bg-green-700">
                  <Save className="h-4 w-4 mr-2" />
                  Salva Modifiche
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Visualizza Immagine DDT */}
        {showImmagine && (
          <div 
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-[70] p-4" 
            onClick={() => setShowImmagine(null)}
          >
            <div className="relative max-w-4xl max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
              <button 
                onClick={() => setShowImmagine(null)}
                className="absolute -top-12 right-0 p-2 bg-black/40 backdrop-blur-md rounded-xl text-white"
              >
                <X className="h-6 w-6" />
              </button>
              <img 
                src={showImmagine} 
                alt="DDT" 
                className="max-h-[80vh] max-w-full rounded-xl object-contain" 
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="bg-slate-800/70 backdrop-blur-sm p-8 rounded-xl text-center"><p class="text-white">Immagine non disponibile</p><p class="text-slate-400 text-sm mt-2">L\'immagine potrebbe essere stata salvata in un formato non supportato</p></div>';
                }}
              />
            </div>
          </div>
        )}
        {storicoModal}
      </div>
    );
  }

  // ============ RENDER: LISTA DDT ============
  return (
    <div className="min-h-screen bg-transparent lg:bg-gray-50">
      {/* Header Mobile */}
      <div className="lg:hidden p-4 pt-2 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-white">Gestione Bolle</h1>
            <p className="text-sm text-slate-400">DDT e documenti di trasporto</p>
          </div>
          <button 
            onClick={() => setShowNuovaBolla(true)}
            className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center shadow-lg"
          >
            <Plus className="h-6 w-6 text-white" />
          </button>
        </div>

        {activeTab !== 'archivio' && (<>
        {/* Search Mobile */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
          <input 
            placeholder="Cerca fornitore o numero..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-xl bg-black/40 backdrop-blur-md border border-slate-700/50 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>

        {/* Filters Mobile */}
        <div className="flex items-center gap-2 overflow-x-auto pb-1">
          <button
            onClick={() => setShowSoloBozze(!showSoloBozze)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
              showSoloBozze 
                ? 'bg-purple-500 text-white' 
                : 'bg-black/40 backdrop-blur-md text-slate-400 border border-slate-700/50'
            }`}
          >
            Solo bozze
          </button>
          <select
            value={filterFornitore}
            onChange={(e) => setFilterFornitore(e.target.value)}
            data-testid="bolle-filtro-fornitore-mobile"
            className="shrink-0 max-w-[55vw] truncate px-3 py-1.5 rounded-full text-xs font-medium bg-black/40 backdrop-blur-md text-slate-300 border border-slate-700"
          >
            <option value="">Tutti fornitori</option>
            {Array.isArray(fornitori) && fornitori.map((f, idx) => (
              <option key={idx} value={typeof f === 'string' ? f : f.nome}>{typeof f === 'string' ? f : f.nome}</option>
            ))}
          </select>
          <select
            value={filterMese}
            onChange={(e) => setFilterMese(e.target.value)}
            className="px-3 py-1.5 rounded-full text-xs font-medium bg-black/40 backdrop-blur-md text-slate-300 border border-slate-700"
          >
            <option value="">Mese</option>
            <option value="1">Gennaio</option>
            <option value="2">Febbraio</option>
            <option value="3">Marzo</option>
            <option value="4">Aprile</option>
            <option value="5">Maggio</option>
            <option value="6">Giugno</option>
            <option value="7">Luglio</option>
            <option value="8">Agosto</option>
            <option value="9">Settembre</option>
            <option value="10">Ottobre</option>
            <option value="11">Novembre</option>
            <option value="12">Dicembre</option>
          </select>
          <select
            value={filterAnno}
            onChange={(e) => setFilterAnno(e.target.value)}
            className="px-3 py-1.5 rounded-full text-xs font-medium bg-black/40 backdrop-blur-md text-slate-300 border border-slate-700"
          >
            <option value="">Anno</option>
            {anniDisponibili.map(anno => (
              <option key={anno} value={anno}>{anno}</option>
            ))}
          </select>
          <select
            value={`${ordinaPer}-${ordine}`}
            onChange={(e) => {
              const [campo, dir] = e.target.value.split('-');
              setOrdinaPer(campo);
              setOrdine(dir);
            }}
            className="px-3 py-1.5 rounded-full text-xs font-medium bg-black/40 backdrop-blur-md text-slate-300 border border-slate-700"
          >
            <option value="numero-desc">N° ↓</option>
            <option value="numero-asc">N° ↑</option>
            <option value="data-desc">Data ↓</option>
            <option value="data-asc">Data ↑</option>
            <option value="fornitore-asc">A-Z</option>
          </select>
        </div>
        </>)}

        {/* Stats Mobile */}
        <div className="grid grid-cols-3 gap-2">
          <div className="bg-slate-800/80 rounded-xl p-3 text-center border border-slate-700/50">
            <p className="text-lg font-bold text-white">{ddtList.length}</p>
            <p className="text-[10px] text-slate-400">Totale DDT</p>
          </div>
          <div className="bg-slate-800/80 rounded-xl p-3 text-center border border-slate-700/50">
            <p className="text-lg font-bold text-yellow-400">{ddtList.filter(d => d.status === 'bozza').length}</p>
            <p className="text-[10px] text-slate-400">Bozze</p>
          </div>
          <div 
            onClick={() => setActiveTab('resi')}
            className="bg-slate-800/80 rounded-xl p-3 text-center border border-slate-700/50 cursor-pointer hover:border-orange-500/50 transition-colors"
          >
            <p className={`text-lg font-bold ${resiInAttesa.length > 0 ? 'text-orange-400' : 'text-green-400'}`}>
              {resiInAttesa.length}
            </p>
            <p className="text-[10px] text-slate-400">Resi NC ⏳</p>
          </div>
        </div>

        {/* Tab Mobile */}
        <div className="flex gap-2 bg-slate-800/50 p-1 rounded-xl">
          <button
            onClick={() => setActiveTab('ddt')}
            className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'ddt' 
                ? 'bg-purple-600 text-white' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            📦 DDT
          </button>
          <button
            onClick={() => setActiveTab('resi')}
            className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-colors relative ${
              activeTab === 'resi' 
                ? 'bg-orange-600 text-white' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            ⏳ Resi
            {resiInAttesa.length > 0 && (
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-xs flex items-center justify-center">
                {resiInAttesa.length}
              </span>
            )}
          </button>
          <button
            onClick={() => { setActiveTab('storico_resi'); loadStoricoResi(); }}
            className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'storico_resi' 
                ? 'bg-blue-600 text-white' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            📋 Storico
          </button>
          <button
            onClick={() => setActiveTab('archivio')}
            data-testid="tab-archivio-mobile"
            className={`flex-1 py-2 px-2 rounded-lg text-sm font-medium transition-colors inline-flex items-center justify-center gap-1 ${
              activeTab === 'archivio'
                ? 'bg-emerald-600 text-white'
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Archive className="h-4 w-4" /> Archivio
          </button>
        </div>
      </div>

      {/* Header Desktop */}
      <div className="hidden lg:block p-4 lg:p-6 space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 flex items-center gap-2">
            <Package className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
            Gestione Bolle
          </h1>
          <div className="flex items-center gap-2">
            {resiInAttesa.length > 0 && (
              <Button 
                onClick={() => setActiveTab('resi')}
                variant="outline"
                className="border-orange-500 text-orange-600 hover:bg-orange-50"
              >
                <AlertTriangle className="h-4 w-4 mr-2" />
                {resiInAttesa.length} Resi in Attesa
              </Button>
            )}
            <Button 
              onClick={() => setShowNuovaBolla(true)}
              className="bg-purple-600 hover:bg-purple-700 w-full sm:w-auto"
            >
              <Plus className="h-4 w-4 mr-2" />
              Nuova Bolla
            </Button>
          </div>
        </div>

        {/* Tab Desktop */}
        <div className="flex gap-2 border-b border-gray-200">
          <button
            onClick={() => setActiveTab('ddt')}
            className={`py-2 px-4 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'ddt' 
                ? 'border-purple-600 text-purple-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            📦 DDT/Bolle ({ddtList.length})
          </button>
          <button
            onClick={() => setActiveTab('resi')}
            className={`py-2 px-4 text-sm font-medium border-b-2 transition-colors relative ${
              activeTab === 'resi' 
                ? 'border-orange-600 text-orange-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            ⏳ Resi in Attesa NC
            {resiInAttesa.length > 0 && (
              <span className="ml-2 px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full text-xs">
                {resiInAttesa.length}
              </span>
            )}
          </button>
          <button
            onClick={() => { setActiveTab('storico_resi'); loadStoricoResi(); }}
            className={`py-2 px-4 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'storico_resi' 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            📋 Storico Resi
          </button>
          <button
            onClick={() => setActiveTab('archivio')}
            data-testid="tab-archivio-desktop"
            className={`py-2 px-4 text-sm font-medium border-b-2 transition-colors inline-flex items-center gap-1.5 ${
              activeTab === 'archivio'
                ? 'border-emerald-600 text-emerald-700'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Archive className="h-4 w-4" /> Archivio
          </button>
        </div>

        {/* Filters Desktop */}
        {activeTab !== 'archivio' && (
        <Card>
          <CardContent className="pt-4">
            <div className="flex flex-col gap-3">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  placeholder="Cerca per numero o fornitore..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="flex flex-wrap gap-2 sm:gap-3">
                <label className="flex items-center gap-2 cursor-pointer text-sm whitespace-nowrap">
                  <div 
                    onClick={() => setShowSoloBozze(!showSoloBozze)}
                    className={`w-10 h-5 rounded-full cursor-pointer transition-colors ${showSoloBozze ? 'bg-purple-600' : 'bg-gray-300'}`}
                  >
                    <div className={`w-4 h-4 rounded-full bg-white mt-0.5 transition-transform ${showSoloBozze ? 'translate-x-5' : 'translate-x-1'}`} />
                  </div>
                  <span className="text-gray-600">Solo bozze</span>
                </label>
                <select
                  value={filterFornitore}
                  onChange={(e) => setFilterFornitore(e.target.value)}
                  className="border rounded-lg px-3 py-2 text-sm bg-white min-w-[120px]"
                >
                  <option value="">Tutti fornitori</option>
                  {Array.isArray(fornitori) && fornitori.map((f, idx) => (
                    <option key={idx} value={typeof f === 'string' ? f : f.nome}>{typeof f === 'string' ? f : f.nome}</option>
                  ))}
                </select>
                <select
                  value={filterMese}
                  onChange={(e) => setFilterMese(e.target.value)}
                  className="border rounded-lg px-3 py-2 text-sm bg-white min-w-[100px]"
                >
                  <option value="">Mese</option>
                  <option value="1">Gennaio</option>
                  <option value="2">Febbraio</option>
                  <option value="3">Marzo</option>
                  <option value="4">Aprile</option>
                  <option value="5">Maggio</option>
                  <option value="6">Giugno</option>
                  <option value="7">Luglio</option>
                  <option value="8">Agosto</option>
                  <option value="9">Settembre</option>
                  <option value="10">Ottobre</option>
                  <option value="11">Novembre</option>
                  <option value="12">Dicembre</option>
                </select>
                <select
                  value={filterAnno}
                  onChange={(e) => setFilterAnno(e.target.value)}
                  className="border rounded-lg px-3 py-2 text-sm bg-white min-w-[90px]"
                >
                  <option value="">Anno</option>
                  {anniDisponibili.map(anno => (
                    <option key={anno} value={anno}>{anno}</option>
                  ))}
                </select>
                <select
                  value={`${ordinaPer}-${ordine}`}
                  onChange={(e) => {
                    const [campo, dir] = e.target.value.split('-');
                    setOrdinaPer(campo);
                    setOrdine(dir);
                  }}
                  className="border rounded-lg px-3 py-2 text-sm bg-white min-w-[100px]"
                >
                  <option value="numero-desc">N° decrescente</option>
                  <option value="numero-asc">N° crescente</option>
                  <option value="data-desc">Data recente</option>
                  <option value="data-asc">Data meno recente</option>
                  <option value="fornitore-asc">Fornitore A-Z</option>
                </select>
              </div>
            </div>
          </CardContent>
        </Card>
        )}
      </div>

      {/* Content */}
      <div className="px-4 lg:px-6 pb-24 lg:pb-6">
        {/* Tab DDT */}
        {activeTab === 'ddt' && (
          <>
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-purple-500" />
          </div>
        ) : ddtList.length === 0 ? (
          <div className="text-center py-12 bg-slate-800/50 lg:bg-white rounded-2xl border border-slate-700 lg:border-gray-100">
            <div className="w-16 h-16 bg-purple-500/20 lg:bg-purple-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Package className="h-8 w-8 text-purple-400" />
            </div>
            <p className="text-slate-400 lg:text-gray-500 mb-2">Nessun DDT trovato</p>
            <p className="text-xs text-slate-500 lg:text-gray-400">Clicca + per aggiungerne uno</p>
          </div>
        ) : (
          <>
            {/* Mobile Cards */}
            <div className="lg:hidden space-y-3">
              {ddtList.map((ddt) => (
                <div 
                  key={ddt.id}
                  onClick={() => apriDDT(ddt)}
                  className="bg-slate-800/80 rounded-2xl p-4 border border-slate-700/50 active:bg-slate-700/50 transition-all"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-bold text-purple-400">DDT #{ddt.numero}</span>
                        {getStatusBadge(ddt.status)}
                      </div>
                      <p className="text-sm text-white font-medium">{ddt.fornitore}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-green-400 text-lg">{formatCurrency(ddt.totale)}</p>
                      <p className="text-xs text-slate-400">{ddt.n_prodotti || ddt.prodotti?.length || 0} prodotti</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-slate-700/50">
                    <span className="text-xs text-slate-400">{formatDate(ddt.data_ddt)}</span>
                    <ArrowRight className="h-4 w-4 text-slate-500" />
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <Card className="hidden lg:block overflow-visible">
              <CardContent className="p-0 overflow-visible">
                <div className="overflow-visible">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">N° DDT</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fornitore</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Data DDT</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Totale</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Prodotti</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Azioni</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {ddtList.map((ddt) => (
                        <tr key={ddt.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => apriDDT(ddt)}>
                          <td className="px-4 py-3">
                            <Badge className="bg-blue-100 text-blue-800">#{ddt.numero}</Badge>
                          </td>
                          <td className="px-4 py-3">{getStatusBadge(ddt.status)}</td>
                          <td className="px-4 py-3 font-medium text-gray-900">{ddt.fornitore}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{formatDate(ddt.data_ddt)}</td>
                          <td className="px-4 py-3">
                            <span className="font-medium">{formatCurrency(ddt.totale)}</span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-600">{ddt.n_prodotti || ddt.prodotti?.length || 0}</td>
                          <td className="px-4 py-3 overflow-visible" onClick={(e) => e.stopPropagation()}>
                            <div className="relative">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={(e) => { e.stopPropagation(); setActionMenuOpen(actionMenuOpen === ddt.id ? null : ddt.id); }}
                            >
                              <MoreVertical className="h-4 w-4" />
                            </Button>
                            
                            {actionMenuOpen === ddt.id && (
                              <div className="absolute right-0 bottom-full mb-1 w-48 bg-white rounded-lg shadow-xl border z-[100]">
                                <div className="py-1">
                                  <button onClick={(e) => { e.stopPropagation(); apriDDT(ddt); setActionMenuOpen(null); }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center gap-2">
                                    <Eye className="h-4 w-4" /> Apri DDT
                                  </button>
                                  {ddt.immagine_url && (
                                    <button onClick={(e) => { e.stopPropagation(); setShowImmagine(ddt.immagine_url); setActionMenuOpen(null); }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center gap-2">
                                      <Image className="h-4 w-4" /> Vedi immagine
                                    </button>
                                  )}
                                  <button onClick={(e) => { e.stopPropagation(); eliminaDDT(ddt.id); setActionMenuOpen(null); }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center gap-2 text-red-600">
                                    <Trash2 className="h-4 w-4" /> Elimina
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>

          {/* Paginazione */}
          {totalDdt > PAGE_SIZE && (
            <div className="flex items-center justify-between mt-4 gap-2" data-testid="ddt-pagination">
              <Button
                variant="outline"
                size="sm"
                disabled={page <= 1 || loading}
                onClick={() => setPage(p => Math.max(1, p - 1))}
                data-testid="ddt-prev-page-btn"
                className="border-slate-700 text-slate-200 lg:border-gray-300 lg:text-gray-700"
              >
                <ChevronLeft className="h-4 w-4 mr-1" /> Precedente
              </Button>
              <span className="text-sm text-slate-300 lg:text-gray-600 text-center" data-testid="ddt-page-info">
                Pagina {page} di {Math.max(1, Math.ceil(totalDdt / PAGE_SIZE))} • {totalDdt} bolle
              </span>
              <Button
                variant="outline"
                size="sm"
                disabled={page >= Math.ceil(totalDdt / PAGE_SIZE) || loading}
                onClick={() => setPage(p => p + 1)}
                data-testid="ddt-next-page-btn"
                className="border-slate-700 text-slate-200 lg:border-gray-300 lg:text-gray-700"
              >
                Successiva <ChevronRight className="h-4 w-4 ml-1" />
              </Button>
            </div>
          )}
          </>
        )}
          </>
        )}

        {/* Tab Resi in Attesa */}
        {activeTab === 'resi' && (
          <div className="space-y-4">
            {/* Header */}
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-bold text-white lg:text-gray-900">Resi in Attesa di NC</h2>
                <p className="text-xs text-slate-400 lg:text-gray-500">
                  {resiInAttesa.length} resi • Totale: {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(resiInAttesa.reduce((s, r) => s + (r.valore_totale || 0), 0))}
                </p>
              </div>
              <Button
                onClick={loadResiInAttesa}
                variant="outline"
                size="sm"
                className="border-slate-700 lg:border-gray-300"
              >
                <RefreshCw className={`h-4 w-4 ${loadingResi ? 'animate-spin' : ''}`} />
              </Button>
            </div>

            {/* Lista Resi */}
            {loadingResi ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
              </div>
            ) : resiInAttesa.length === 0 ? (
              <div className="text-center py-12 bg-slate-800/50 lg:bg-white rounded-2xl border border-slate-700 lg:border-gray-100">
                <div className="w-16 h-16 bg-green-500/20 lg:bg-green-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="h-8 w-8 text-green-400" />
                </div>
                <p className="text-green-400 lg:text-green-600 font-medium mb-2">Nessun reso in attesa! 🎉</p>
                <p className="text-xs text-slate-500 lg:text-gray-400">Tutte le note credito sono state ricevute</p>
              </div>
            ) : (
              <div className="space-y-3">
                {resiInAttesa.map((reso) => (
                  <Card key={reso.id} className="bg-black/40 backdrop-blur-md border-slate-700 border-l-4 border-l-orange-500 lg:bg-white lg:border-gray-200">
                    <CardContent className="p-4">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge className="bg-orange-500/20 text-orange-400 border-orange-500/30">
                              ⏳ In Attesa NC
                            </Badge>
                            <span className="text-xs text-slate-500 lg:text-gray-500">
                              DDT #{reso.ddt_numero || '-'}
                            </span>
                          </div>
                          <p className="font-medium text-white lg:text-gray-900">{reso.fornitore}</p>
                          <p className="text-xs text-slate-400 lg:text-gray-500 mt-1">
                            {reso.prodotti?.length || 0} prodotti • {new Date(reso.data_registrazione).toLocaleDateString('it-IT')}
                          </p>
                          
                          {/* Lista prodotti resi */}
                          <div className="mt-3 space-y-1">
                            {reso.prodotti?.slice(0, 3).map((prod, idx) => (
                              <div key={idx} className="text-xs flex justify-between bg-slate-900/50 lg:bg-gray-50 px-2 py-1 rounded">
                                <span className="text-slate-300 lg:text-gray-700 truncate">{prod.nome}</span>
                                <span className="text-orange-400 lg:text-orange-600 ml-2">
                                  {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(prod.valore || 0)}
                                </span>
                              </div>
                            ))}
                            {reso.prodotti?.length > 3 && (
                              <p className="text-xs text-slate-500 px-2">+{reso.prodotti.length - 3} altri prodotti</p>
                            )}
                          </div>
                        </div>
                        
                        <div className="text-right flex flex-col items-end gap-2">
                          <p className="font-bold text-lg text-orange-400 lg:text-orange-600">
                            {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(reso.valore_totale || 0)}
                          </p>
                          <div className="flex gap-2">
                            <Button
                              onClick={() => deleteReso(reso.id)}
                              size="sm"
                              variant="outline"
                              className="border-red-500/50 text-red-400 hover:bg-red-500/20 text-xs"
                            >
                              <Trash2 className="h-3 w-3" />
                            </Button>
                            <Button
                              onClick={() => toggleNotaCreditoReso(reso.id)}
                              size="sm"
                              className="bg-green-600 hover:bg-green-700 text-white text-xs"
                            >
                              <Check className="h-3 w-3 mr-1" />
                              NC Ricevuta
                            </Button>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Tab Storico Resi */}
        {activeTab === 'storico_resi' && (
          <div className="space-y-4">
            {/* Header */}
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <h2 className="text-lg font-bold text-white lg:text-gray-900">Storico Completo Resi</h2>
                {storicoRiepilogo && (
                  <p className="text-xs text-slate-400 lg:text-gray-500">
                    {storicoResi.length} resi • Totale: {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(storicoRiepilogo.totale_valore)}
                  </p>
                )}
              </div>
              <div className="flex items-center gap-2">
                <select
                  value={filtroStoricoResi}
                  onChange={(e) => { setFiltroStoricoResi(e.target.value); loadStoricoResi(e.target.value); }}
                  className="bg-slate-800 lg:bg-white border border-slate-700 lg:border-gray-300 rounded-lg px-3 py-2 text-sm text-white lg:text-gray-900"
                >
                  <option value="tutti">Tutti</option>
                  <option value="in_attesa">In Attesa NC</option>
                  <option value="completato">NC Ricevuta</option>
                </select>
                <Button
                  onClick={() => loadStoricoResi()}
                  variant="outline"
                  size="sm"
                  className="border-slate-700 lg:border-gray-300"
                >
                  <RefreshCw className={`h-4 w-4 ${loadingStoricoResi ? 'animate-spin' : ''}`} />
                </Button>
              </div>
            </div>

            {/* Riepilogo Cards */}
            {storicoRiepilogo && (
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                <div className="bg-slate-800/80 lg:bg-blue-50 rounded-xl p-3 border border-slate-700 lg:border-blue-200">
                  <p className="text-2xl font-bold text-blue-400 lg:text-blue-600">{storicoRiepilogo.totale_in_attesa + storicoRiepilogo.totale_completati}</p>
                  <p className="text-xs text-slate-400 lg:text-blue-700">Resi Totali</p>
                </div>
                <div className="bg-slate-800/80 lg:bg-orange-50 rounded-xl p-3 border border-slate-700 lg:border-orange-200">
                  <p className="text-2xl font-bold text-orange-400 lg:text-orange-600">{storicoRiepilogo.totale_in_attesa}</p>
                  <p className="text-xs text-slate-400 lg:text-orange-700">In Attesa NC</p>
                </div>
                <div className="bg-slate-800/80 lg:bg-green-50 rounded-xl p-3 border border-slate-700 lg:border-green-200">
                  <p className="text-2xl font-bold text-green-400 lg:text-green-600">{storicoRiepilogo.totale_completati}</p>
                  <p className="text-xs text-slate-400 lg:text-green-700">NC Ricevute</p>
                </div>
                <div className="bg-slate-800/80 lg:bg-purple-50 rounded-xl p-3 border border-slate-700 lg:border-purple-200">
                  <p className="text-xl font-bold text-purple-400 lg:text-purple-600">
                    {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(storicoRiepilogo.valore_in_attesa)}
                  </p>
                  <p className="text-xs text-slate-400 lg:text-purple-700">Valore in Attesa</p>
                </div>
              </div>
            )}

            {/* Lista Storico */}
            {loadingStoricoResi ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
              </div>
            ) : storicoResi.length === 0 ? (
              <div className="text-center py-12 bg-slate-800/50 lg:bg-white rounded-2xl border border-slate-700 lg:border-gray-100">
                <div className="w-16 h-16 bg-blue-500/20 lg:bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <History className="h-8 w-8 text-blue-400" />
                </div>
                <p className="text-blue-400 lg:text-blue-600 font-medium mb-2">Nessun reso trovato</p>
                <p className="text-xs text-slate-500 lg:text-gray-400">Non ci sono resi registrati con i filtri selezionati</p>
              </div>
            ) : (
              <div className="space-y-3">
                {storicoResi.map((reso) => (
                  <Card 
                    key={reso.id} 
                    className={`bg-black/40 backdrop-blur-md border-slate-700 border-l-4 lg:bg-white lg:border-gray-200 ${
                      reso.nota_credito_ricevuta 
                        ? 'border-l-green-500' 
                        : 'border-l-orange-500'
                    }`}
                  >
                    <CardContent className="p-4">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2 flex-wrap">
                            {reso.nota_credito_ricevuta ? (
                              <Badge className="bg-green-500/20 text-green-400 border-green-500/30">
                                <CheckCircle className="h-3 w-3 mr-1" />
                                NC Ricevuta
                              </Badge>
                            ) : (
                              <Badge className="bg-orange-500/20 text-orange-400 border-orange-500/30">
                                ⏳ In Attesa NC
                              </Badge>
                            )}
                            <span className="text-xs text-slate-500 lg:text-gray-500">
                              DDT #{reso.ddt_numero || '-'}
                            </span>
                          </div>
                          <p className="font-medium text-white lg:text-gray-900">{reso.fornitore}</p>
                          <p className="text-xs text-slate-400 lg:text-gray-500 mt-1">
                            {reso.prodotti?.length || 0} prodotti • Registrato: {new Date(reso.data_registrazione).toLocaleDateString('it-IT')}
                            {reso.data_nota_credito && (
                              <span className="text-green-400 lg:text-green-600 ml-2">
                                • NC: {new Date(reso.data_nota_credito).toLocaleDateString('it-IT')}
                              </span>
                            )}
                          </p>
                          
                          {/* Lista prodotti */}
                          <div className="mt-3 space-y-1">
                            {reso.prodotti?.slice(0, 3).map((prod, idx) => (
                              <div key={idx} className="text-xs flex justify-between bg-slate-900/50 lg:bg-gray-50 px-2 py-1 rounded">
                                <span className="text-slate-300 lg:text-gray-700 truncate">
                                  {prod.nome}
                                  {prod.motivo && <span className="text-orange-400 lg:text-orange-600 ml-1">({prod.motivo})</span>}
                                </span>
                                <span className={`ml-2 ${reso.nota_credito_ricevuta ? 'text-green-400 lg:text-green-600' : 'text-orange-400 lg:text-orange-600'}`}>
                                  {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(prod.valore || 0)}
                                </span>
                              </div>
                            ))}
                            {reso.prodotti?.length > 3 && (
                              <p className="text-xs text-slate-500 px-2">+{reso.prodotti.length - 3} altri prodotti</p>
                            )}
                          </div>
                        </div>
                        
                        <div className="text-right flex flex-col items-end gap-2">
                          <p className={`font-bold text-lg ${reso.nota_credito_ricevuta ? 'text-green-400 lg:text-green-600' : 'text-orange-400 lg:text-orange-600'}`}>
                            {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(reso.valore_totale || 0)}
                          </p>
                          <div className="flex gap-2">
                            <Button
                              onClick={() => deleteReso(reso.id)}
                              size="sm"
                              variant="outline"
                              className="border-red-500/50 text-red-400 hover:bg-red-500/20 text-xs"
                              title="Elimina reso"
                            >
                              <Trash2 className="h-3 w-3" />
                            </Button>
                            {!reso.nota_credito_ricevuta && (
                              <Button
                                onClick={() => toggleNotaCreditoReso(reso.id)}
                                size="sm"
                                className="bg-green-600 hover:bg-green-700 text-white text-xs"
                              >
                                <Check className="h-3 w-3 mr-1" />
                                NC
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Tab Archivio */}
        {activeTab === 'archivio' && <ArchivioDDT />}
      </div>

      {storicoModal}
      {/* Modal: Nuova Bolla - FULLSCREEN su mobile */}
      {showNuovaBolla && (
        <div className="fixed inset-0 lg:bg-black/50 flex flex-col lg:items-center lg:justify-center z-[100]">
          {/* Mobile Background Image */}
          <div 
            className="lg:hidden fixed inset-0 bg-cover bg-center bg-no-repeat"
            style={{ 
              backgroundImage: 'url(/images/login-bg.png)',
              top: 'calc(-1 * env(safe-area-inset-top, 50px))',
              left: 0,
              right: 0,
              bottom: 'calc(-1 * env(safe-area-inset-bottom, 50px))',
              zIndex: 0,
            }}
          >
            <div className="absolute inset-0 bg-black/60" />
          </div>
          
          <div className="flex-1 lg:flex-none lg:bg-white lg:rounded-xl w-full lg:max-w-lg lg:max-h-[90vh] overflow-hidden flex flex-col relative z-10">
            {/* Header */}
            <div className="p-4 border-b border-white/10 lg:border-gray-200 flex items-center justify-between bg-transparent lg:bg-white flex-shrink-0" style={{ paddingTop: 'calc(env(safe-area-inset-top, 44px) + 16px)' }}>
              <div className="flex items-center gap-3">
                <button onClick={closeModal} className="p-2 bg-black/40 backdrop-blur-md lg:bg-gray-100 rounded-xl lg:hidden">
                  <ArrowLeft className="h-5 w-5 text-white" />
                </button>
                <h2 className="text-lg font-bold text-white lg:text-gray-900">
                  {step === 1 && 'Seleziona Ordine'}
                  {step === 2 && 'Scansiona DDT'}
                  {step === 3 && 'Verifica Prodotti'}
                </h2>
              </div>
              <button onClick={closeModal} className="p-2 bg-black/40 backdrop-blur-md lg:bg-gray-100 rounded-xl hidden lg:block">
                <X className="h-4 w-4 text-white lg:text-gray-500" />
              </button>
            </div>
            
            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4 pb-32 lg:pb-4">
              {/* STEP 1 */}
              {step === 1 && (
                <div className="space-y-4">
                  {loadingOrdini ? (
                    <div className="flex items-center justify-center py-12">
                      <Loader2 className="h-8 w-8 animate-spin text-purple-500" />
                    </div>
                  ) : ordiniAttesa.length === 0 ? (
                    <div className="text-center py-8 bg-black/40 backdrop-blur-md lg:bg-gray-50 rounded-xl border border-slate-700 lg:border-gray-200">
                      <ShoppingCart className="h-12 w-12 mx-auto mb-3 text-slate-600 lg:text-gray-300" />
                      <p className="text-slate-400 lg:text-gray-500">Nessun ordine in attesa.</p>
                      <p className="text-sm mt-2 text-slate-500 lg:text-gray-400">Puoi procedere senza ordine</p>
                    </div>
                  ) : (
                    <div className="space-y-3 max-h-[50vh] overflow-y-auto">
                      {ordiniAttesa.map((ordine) => (
                        <div
                          key={ordine.id}
                          onClick={() => setSelectedOrdine(selectedOrdine?.id === ordine.id ? null : ordine)}
                          className={`p-4 rounded-xl cursor-pointer transition-all border ${
                            selectedOrdine?.id === ordine.id 
                              ? 'border-purple-500 bg-purple-500/20 lg:bg-purple-50' 
                              : 'border-slate-700 lg:border-gray-200 bg-black/40 backdrop-blur-md lg:bg-white hover:border-purple-500/50'
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="font-semibold text-white lg:text-gray-900">{ordine.fornitore}</p>
                              <p className="text-sm text-slate-400 lg:text-gray-500">
                                {ordine.prodotti_attesi?.length || ordine.prodotti?.length || 0} prodotti
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="font-bold text-purple-400 lg:text-purple-600">{formatCurrency(calcolaTotalePrevisto(ordine))}</p>
                              {selectedOrdine?.id === ordine.id && <CheckCircle className="h-5 w-5 text-purple-400 lg:text-purple-600 mt-1" />}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* STEP 2 */}
              {step === 2 && (
                <div className="space-y-4">
                  {selectedOrdine && (
                    <div className="p-4 bg-purple-500/20 lg:bg-purple-50 rounded-xl border border-purple-500/30 lg:border-purple-200">
                      <p className="text-sm text-purple-400 lg:text-purple-600 font-medium">Ordine selezionato:</p>
                      <p className="font-bold text-purple-300 lg:text-purple-800">{selectedOrdine.fornitore}</p>
                    </div>
                  )}
                  
                  <div className="border-2 border-dashed border-slate-600 lg:border-gray-300 rounded-xl p-6 text-center bg-slate-800/50 lg:bg-transparent">
                    {!selectedFile && selectedFiles.length === 0 ? (
                      <>
                        <Upload className="h-12 w-12 mx-auto text-slate-500 lg:text-gray-400 mb-4" />
                        <p className="text-slate-300 lg:text-gray-600 mb-2">Carica il DDT</p>
                        <p className="text-xs text-slate-500 lg:text-gray-400 mb-4">Immagini, PDF, Excel (XLS, XLSX)</p>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                          <button 
                            onClick={() => fileInputRef.current?.click()}
                            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-medium"
                          >
                            Seleziona File
                          </button>
                          <button 
                            onClick={() => multiFileInputRef.current?.click()}
                            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium flex items-center justify-center gap-2"
                          >
                            <Plus className="h-4 w-4" />
                            Carica Multipli
                          </button>
                        </div>
                        <input 
                          ref={fileInputRef} 
                          type="file" 
                          accept="image/*,.pdf,.xls,.xlsx,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                          onChange={handleFileSelect} 
                          className="hidden" 
                        />
                        <input 
                          ref={multiFileInputRef} 
                          type="file" 
                          multiple
                          accept="image/*,.pdf,.xls,.xlsx,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                          onChange={handleMultipleFileSelect} 
                          className="hidden" 
                        />
                      </>
                    ) : selectedFiles.length > 0 ? (
                      /* Vista upload multiplo */
                      <div className="space-y-4">
                        <div className="flex items-center justify-between">
                          <h3 className="font-semibold text-white lg:text-gray-900">
                            {selectedFiles.length} file selezionati
                          </h3>
                          <button 
                            onClick={() => { setSelectedFiles([]); setUploadResults([]); }}
                            className="text-sm text-red-400 hover:text-red-300"
                          >
                            Rimuovi tutti
                          </button>
                        </div>
                        
                        <div className="max-h-48 overflow-y-auto space-y-2">
                          {selectedFiles.map((f, idx) => (
                            <div key={idx} className={`flex items-center justify-between p-2 rounded-lg ${
                              f.status === 'success' ? 'bg-green-500/20 border border-green-500/30' :
                              f.status === 'duplicate' ? 'bg-yellow-500/20 border border-yellow-500/30' :
                              f.status === 'error' ? 'bg-red-500/20 border border-red-500/30' :
                              f.status === 'processing' ? 'bg-blue-500/20 border border-blue-500/30' :
                              'bg-slate-700/50 lg:bg-gray-100 border border-slate-600 lg:border-gray-200'
                            }`}>
                              <div className="flex items-center gap-2 flex-1 min-w-0">
                                <span className="text-lg flex-shrink-0">{getFileIcon(f.tipoFile)}</span>
                                <div className="min-w-0">
                                  <span className="text-sm text-white lg:text-gray-900 truncate block">{f.name}</span>
                                  {f.status === 'duplicate' && f.ddt_esistente && (
                                    <span className="text-xs text-yellow-400 lg:text-yellow-600">
                                      Già presente: #{f.ddt_esistente.numero} del {f.ddt_esistente.data_ddt}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 flex-shrink-0">
                                {f.status === 'pending' && <Clock className="h-4 w-4 text-slate-400" />}
                                {f.status === 'processing' && <Loader2 className="h-4 w-4 animate-spin text-blue-400" />}
                                {f.status === 'success' && <CheckCircle className="h-4 w-4 text-green-400" />}
                                {f.status === 'duplicate' && <AlertTriangle className="h-4 w-4 text-yellow-400" />}
                                {f.status === 'error' && <AlertCircle className="h-4 w-4 text-red-400" />}
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {uploading && (
                          <div className="space-y-2">
                            <div className="flex items-center justify-between text-sm">
                              <span className="text-slate-400 lg:text-gray-500">Elaborazione...</span>
                              <span className="text-purple-400 lg:text-purple-600">{currentUploadIndex + 1} / {selectedFiles.length}</span>
                            </div>
                            <div className="w-full bg-slate-700 lg:bg-gray-200 rounded-full h-2">
                              <div 
                                className="bg-purple-600 h-2 rounded-full transition-all duration-300"
                                style={{ width: `${((currentUploadIndex + 1) / selectedFiles.length) * 100}%` }}
                              />
                            </div>
                          </div>
                        )}
                        
                        {!uploading && !showReviewMode && (
                          <button 
                            onClick={processAllFiles}
                            className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-medium flex items-center justify-center gap-2"
                          >
                            <Upload className="h-5 w-5" />
                            Analizza {selectedFiles.length} bolle
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="space-y-4">
                        {previewUrl ? (
                          <img src={previewUrl} alt="Preview DDT" className="max-h-48 mx-auto rounded-lg shadow" />
                        ) : (
                          <div className="flex flex-col items-center">
                            <span className="text-5xl mb-2">{getFileIcon(selectedFile.tipoFile)}</span>
                            <p className="font-medium text-white lg:text-gray-800">{selectedFile.name}</p>
                            <span className={`mt-1 px-2 py-1 rounded-full text-xs font-medium ${
                              selectedFile.tipoFile === 'pdf' ? 'bg-red-500/20 text-red-400 lg:bg-red-100 lg:text-red-700' :
                              selectedFile.tipoFile.includes('xls') ? 'bg-green-500/20 text-green-400 lg:bg-green-100 lg:text-green-700' :
                              'bg-blue-500/20 text-blue-400 lg:bg-blue-100 lg:text-blue-700'
                            }`}>
                              {selectedFile.tipoFile.toUpperCase()}
                            </span>
                          </div>
                        )}
                        <div className="flex gap-2 justify-center">
                          <button 
                            onClick={() => { setSelectedFile(null); setPreviewUrl(null); setAnalisiResult(null); }}
                            className="px-4 py-2 bg-slate-700 lg:bg-gray-100 text-white lg:text-gray-700 rounded-xl font-medium text-sm"
                          >
                            Cambia
                          </button>
                          <button 
                            onClick={uploadAndAnalyze} 
                            disabled={uploading || analyzing} 
                            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-medium text-sm flex items-center gap-2 disabled:opacity-50"
                          >
                            {uploading || analyzing ? (
                              <><Loader2 className="h-4 w-4 animate-spin" />Analisi...</>
                            ) : (
                              <><Eye className="h-4 w-4" />Analizza</>
                            )}
                          </button>
                        </div>
                        {(uploading || analyzing) && selectedFile.tipoFile !== 'image' && (
                          <p className="text-xs text-slate-500 lg:text-gray-500">L&apos;analisi di {selectedFile.tipoFile.toUpperCase()} può richiedere più tempo...</p>
                        )}
                      </div>
                    )}
                  </div>

                  {analisiResult && !selectedOrdine && (
                    <div className="space-y-4 border-t border-slate-700 lg:border-gray-200 pt-4">
                      <h3 className="font-bold text-white lg:text-gray-900">Risultato Analisi</h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-lg">
                          <label className="text-xs text-slate-400 lg:text-gray-500">Fornitore</label>
                          <p className="font-medium text-white lg:text-gray-900">{analisiResult.fornitore || '-'}</p>
                        </div>
                        <div className="bg-black/40 backdrop-blur-md lg:bg-gray-50 p-3 rounded-lg">
                          <label className="text-xs text-slate-400 lg:text-gray-500">Data</label>
                          <p className="font-medium text-white lg:text-gray-900">{analisiResult.data_ddt || '-'}</p>
                        </div>
                      </div>
                      <p className="text-sm text-slate-400 lg:text-gray-600">{analisiResult.prodotti?.length || 0} prodotti trovati</p>
                    </div>
                  )}
                </div>
              )}

              {/* STEP 3 - Verifica Prodotti */}
              {step === 3 && prodottiVerifica.length > 0 && (
                <div className="space-y-4">
                  {/* Banner Upload Multiplo */}
                  {showReviewMode && analisiMultiple.length > 1 && (
                    <div className="p-3 bg-purple-500/20 border border-purple-500/30 rounded-xl">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-purple-400 font-bold">
                            DDT {getDDTCorrenteInfo()?.corrente}/{getDDTCorrenteInfo()?.totali}
                          </span>
                          <span className="text-sm text-purple-300 truncate max-w-[150px]">
                            {getDDTCorrenteInfo()?.fileName}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-purple-300">
                            {getDDTCorrenteInfo()?.processati} salvati
                          </span>
                          <div className="w-20 h-2 bg-purple-900 rounded-full overflow-hidden">
                            <div 
                              className="h-full bg-purple-500 transition-all"
                              style={{ width: `${((getDDTCorrenteInfo()?.corrente || 0) / (getDDTCorrenteInfo()?.totali || 1)) * 100}%` }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Info documento */}
                  <div className="p-4 bg-black/40 backdrop-blur-md lg:bg-gray-50 rounded-xl">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-bold text-lg text-white lg:text-gray-900">{analisiResult?.fornitore || 'Fornitore'}</p>
                        <p className="text-sm text-slate-400 lg:text-gray-500">Data: {analisiResult?.data_ddt || '-'} • N° {analisiResult?.numero_ddt || '-'}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-slate-400 lg:text-gray-500">Totale</p>
                        <p className="font-bold text-green-400 lg:text-green-600">
                          {formatCurrency(prodottiVerifica
                            .filter(p => p.stato_consegna === 'ricevuto')
                            .reduce((sum, p) => sum + ((p.quantita || 0) * (p.prezzo_unitario || 0)), 0))}
                        </p>
                      </div>
                    </div>
                    <p className="text-xs text-amber-400 lg:text-amber-600">
                      ⚠️ Seleziona lo stato di consegna per ogni prodotto prima di salvare
                    </p>
                  </div>

                  {/* CONFRONTO ORDINE vs DDT */}
                  {confronto && confronto.items && confronto.items.length > 0 && (
                    <div className="p-4 bg-gradient-to-r from-purple-900/40 to-blue-900/40 lg:from-purple-50 lg:to-blue-50 rounded-xl border border-purple-500/30 lg:border-purple-300">
                      <div className="flex items-center gap-2 mb-3">
                        <Package className="h-5 w-5 text-purple-400 lg:text-purple-600" />
                        <h3 className="font-bold text-white lg:text-gray-900">Confronto Ordine vs DDT Ricevuto</h3>
                      </div>
                      
                      {/* Riepilogo statistiche */}
                      <div className="grid grid-cols-4 gap-2 mb-3">
                        <div className="text-center p-2 bg-green-500/20 rounded-lg">
                          <p className="text-lg font-bold text-green-400 lg:text-green-600">
                            {confronto.items.filter(i => i.status === 'ok').length}
                          </p>
                          <p className="text-xs text-green-300 lg:text-green-700">OK</p>
                        </div>
                        <div className="text-center p-2 bg-yellow-500/20 rounded-lg">
                          <p className="text-lg font-bold text-yellow-400 lg:text-yellow-600">
                            {confronto.items.filter(i => i.status === 'variazione').length}
                          </p>
                          <p className="text-xs text-yellow-300 lg:text-yellow-700">Variazioni</p>
                        </div>
                        <div className="text-center p-2 bg-red-500/20 rounded-lg">
                          <p className="text-lg font-bold text-red-400 lg:text-red-600">
                            {confronto.items.filter(i => i.status === 'mancante').length}
                          </p>
                          <p className="text-xs text-red-300 lg:text-red-700">Mancanti</p>
                        </div>
                        <div className="text-center p-2 bg-blue-500/20 rounded-lg">
                          <p className="text-lg font-bold text-blue-400 lg:text-blue-600">
                            {confronto.items.filter(i => i.status === 'extra').length}
                          </p>
                          <p className="text-xs text-blue-300 lg:text-blue-700">Extra</p>
                        </div>
                      </div>

                      {/* Totali */}
                      <div className="flex justify-between text-sm mb-3 px-2">
                        <div>
                          <span className="text-slate-400 lg:text-gray-500">Ordinato: </span>
                          <span className="font-bold text-white lg:text-gray-900">{formatCurrency(confronto.totaleOrdinato)}</span>
                        </div>
                        <div>
                          <span className="text-slate-400 lg:text-gray-500">Ricevuto: </span>
                          <span className={`font-bold ${confronto.totaleRicevuto > confronto.totaleOrdinato ? 'text-red-400' : 'text-green-400'}`}>
                            {formatCurrency(confronto.totaleRicevuto)}
                          </span>
                        </div>
                      </div>

                      {/* Dettaglio problemi (solo se ci sono) */}
                      {confronto.items.some(i => i.status !== 'ok') && (
                        <div className="space-y-2 max-h-40 overflow-y-auto">
                          {/* Prodotti mancanti */}
                          {confronto.items.filter(i => i.status === 'mancante').map((item, idx) => (
                            <div key={`mancante-${idx}`} className="flex items-center gap-2 p-2 bg-red-500/10 rounded text-sm">
                              <AlertTriangle className="h-4 w-4 text-red-400" />
                              <span className="text-red-300 lg:text-red-700 font-medium">{item.nome}</span>
                              <span className="text-red-200 lg:text-red-500 text-xs ml-auto">
                                Ordinato {item.ordinato?.quantita} {item.ordinato?.unita} - NON RICEVUTO
                              </span>
                            </div>
                          ))}
                          
                          {/* Prodotti extra */}
                          {confronto.items.filter(i => i.status === 'extra').map((item, idx) => (
                            <div key={`extra-${idx}`} className="flex items-center gap-2 p-2 bg-blue-500/10 rounded text-sm">
                              <Plus className="h-4 w-4 text-blue-400" />
                              <span className="text-blue-300 lg:text-blue-700 font-medium">{item.nome}</span>
                              <span className="text-blue-200 lg:text-blue-500 text-xs ml-auto">
                                NON ORDINATO - Ricevuto {item.ricevuto?.quantita} {item.ricevuto?.unita}
                              </span>
                            </div>
                          ))}
                          
                          {/* Variazioni prezzo significative */}
                          {confronto.items.filter(i => i.status === 'variazione' && Math.abs(i.variazionePrezzo) >= 5).map((item, idx) => (
                            <div key={`var-${idx}`} className="flex items-center gap-2 p-2 bg-yellow-500/10 rounded text-sm">
                              {item.variazionePrezzo > 0 ? (
                                <TrendingUp className="h-4 w-4 text-red-400" />
                              ) : (
                                <TrendingDown className="h-4 w-4 text-green-400" />
                              )}
                              <span className="text-yellow-300 lg:text-yellow-700 font-medium">{item.nome}</span>
                              <span className={`text-xs ml-auto ${item.variazionePrezzo > 0 ? 'text-red-400' : 'text-green-400'}`}>
                                Prezzo: €{item.ordinato?.prezzo?.toFixed(2)} → €{item.ricevuto?.prezzo?.toFixed(2)} 
                                ({item.variazionePrezzo > 0 ? '+' : ''}{item.variazionePrezzo.toFixed(1)}%)
                              </span>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Tutto OK */}
                      {confronto.items.every(i => i.status === 'ok') && (
                        <div className="flex items-center gap-2 p-2 bg-green-500/20 rounded">
                          <CheckCircle className="h-5 w-5 text-green-400" />
                          <span className="text-green-300 lg:text-green-700 font-medium">
                            DDT conforme all&apos;ordine! Tutti i prodotti corrispondono.
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Legenda stati */}
                  <div className="flex flex-wrap gap-2 text-xs mb-2">
                    <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded">✅ Ricevuto</span>
                    <span className="px-2 py-1 bg-yellow-500/20 text-yellow-400 rounded">⚠️ Parziale</span>
                    <span className="px-2 py-1 bg-red-500/20 text-red-400 rounded">❌ Non consegnato</span>
                    <span className="px-2 py-1 bg-orange-500/20 text-orange-400 rounded">↩️ Reso</span>
                  </div>

                  {/* Lista prodotti con stato consegna */}
                  <div className="max-h-[45vh] overflow-y-auto space-y-2 pb-4">
                    {prodottiVerifica.map((prodotto, idx) => (
                      <div 
                        key={prodotto.id || idx} 
                        className={`p-3 rounded-xl border transition-all ${
                          prodotto.stato_consegna === 'ricevuto' 
                            ? 'bg-slate-800 border-green-500/30 lg:bg-white lg:border-green-300' 
                            : prodotto.stato_consegna === 'parziale'
                            ? 'bg-slate-800 border-yellow-500/30 lg:bg-yellow-50 lg:border-yellow-300'
                            : prodotto.stato_consegna === 'reso'
                            ? 'bg-slate-900/50 border-orange-500/30 lg:bg-orange-50 lg:border-orange-300'
                            : 'bg-slate-900/50 border-red-500/30 lg:bg-red-50 lg:border-red-300 opacity-70'
                        }`}
                      >
                        <div className="flex items-start gap-3">
                          {/* Selettore stato consegna */}
                          <div className="flex flex-col gap-1 flex-shrink-0">
                            <select
                              value={prodotto.stato_consegna}
                              onChange={(e) => {
                                const updated = [...prodottiVerifica];
                                const newStato = e.target.value;
                                updated[idx].stato_consegna = newStato;
                                updated[idx].arrivato = newStato === 'ricevuto' || newStato === 'parziale';
                                // Reset quantità ricevuta se non consegnato o reso
                                if (newStato === 'non_consegnato' || newStato === 'reso') {
                                  updated[idx].quantita_ricevuta = 0;
                                } else if (newStato === 'ricevuto') {
                                  updated[idx].quantita_ricevuta = updated[idx].quantita_originale;
                                }
                                setProdottiVerifica(updated);
                              }}
                              className={`text-xs px-2 py-1 rounded-lg border-0 cursor-pointer ${
                                prodotto.stato_consegna === 'ricevuto' 
                                  ? 'bg-green-600 text-white'
                                  : prodotto.stato_consegna === 'parziale'
                                  ? 'bg-yellow-600 text-white'
                                  : prodotto.stato_consegna === 'reso'
                                  ? 'bg-orange-600 text-white'
                                  : 'bg-red-600 text-white'
                              }`}
                            >
                              <option value="ricevuto">✅ Ricevuto</option>
                              <option value="parziale">⚠️ Parziale</option>
                              <option value="non_consegnato">❌ Non conseg.</option>
                              <option value="reso">↩️ Reso</option>
                            </select>
                          </div>
                          
                          {/* Info prodotto */}
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                              {prodotto.codice_prodotto && (
                                <span className="px-2 py-0.5 bg-purple-500/20 text-purple-400 lg:bg-purple-100 lg:text-purple-700 rounded text-xs font-mono">
                                  {prodotto.codice_prodotto}
                                </span>
                              )}
                              <p className="font-medium text-white lg:text-gray-900 text-sm truncate flex-1">{prodotto.nome}</p>
                            </div>
                            
                            {/* Confronto prezzo unitario - NUOVO DESIGN - CLICCABILE per storico */}
                            {prodotto.confronto_prezzo?.ultimo_prezzo_unitario && (
                              <div 
                                onClick={() => mostraStoricoProdotto(prodotto)}
                                className={`flex items-center gap-2 mb-2 p-2 rounded-lg text-xs cursor-pointer hover:opacity-80 transition-opacity ${
                                prodotto.confronto_prezzo.trend === 'aumento' 
                                  ? 'bg-red-500/20 lg:bg-red-50' 
                                  : prodotto.confronto_prezzo.trend === 'diminuzione'
                                  ? 'bg-green-500/20 lg:bg-green-50'
                                  : 'bg-slate-700/50 lg:bg-gray-50'
                              }`}
                                title="Clicca per vedere lo storico acquisti"
                              >
                                <div className="flex-1">
                                  <span className="text-slate-400 lg:text-gray-500">Ultimo: </span>
                                  <span className="text-white lg:text-gray-700 font-medium">
                                    €{prodotto.confronto_prezzo.ultimo_prezzo_unitario.toFixed(2)}/{prodotto.unita_misura}
                                  </span>
                                  <span className="ml-2 text-slate-500 lg:text-gray-400">{dataBreve(prodotto.confronto_prezzo.data_ultimo_acquisto) ? `del ${dataBreve(prodotto.confronto_prezzo.data_ultimo_acquisto)} · ` : ''}({prodotto.confronto_prezzo.numero_acquisti || 0} acquisti)</span>
                                </div>
                                {prodotto.confronto_prezzo.variazione_euro !== null && (
                                  <div className={`font-bold ${
                                    prodotto.confronto_prezzo.trend === 'aumento' 
                                      ? 'text-red-400 lg:text-red-600' 
                                      : prodotto.confronto_prezzo.trend === 'diminuzione'
                                      ? 'text-green-400 lg:text-green-600'
                                      : 'text-slate-400 lg:text-gray-500'
                                  }`}>
                                    {prodotto.confronto_prezzo.trend === 'aumento' && (
                                      <>
                                        <TrendingUp className="h-3 w-3 inline mr-1" />
                                        +€{prodotto.confronto_prezzo.variazione_euro.toFixed(2)}/{prodotto.unita_misura}
                                        <span className="ml-1 opacity-75">(+{prodotto.confronto_prezzo.variazione_percentuale}%)</span>
                                      </>
                                    )}
                                    {prodotto.confronto_prezzo.trend === 'diminuzione' && (
                                      <>
                                        <TrendingDown className="h-3 w-3 inline mr-1" />
                                        €{prodotto.confronto_prezzo.variazione_euro.toFixed(2)}/{prodotto.unita_misura}
                                        <span className="ml-1 opacity-75">({prodotto.confronto_prezzo.variazione_percentuale}%)</span>
                                      </>
                                    )}
                                    {prodotto.confronto_prezzo.trend === 'stabile' && (
                                      <>
                                        <Minus className="h-3 w-3 inline mr-1" />
                                        stabile 📊
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            {prodotto.confronto_prezzo?.trend === 'nuovo' && (
                              <div className="mb-2 px-2 py-1 bg-blue-500/20 lg:bg-blue-50 rounded-lg text-xs text-blue-400 lg:text-blue-600">
                                🆕 Primo acquisto di questo prodotto
                              </div>
                            )}
                            {prodotto.confronto_prezzo?.possibile_inversione_qta_prezzo && (
                              <div className="mb-2 px-2 py-1 bg-amber-500/20 lg:bg-amber-50 rounded-lg text-[11px] text-amber-500 lg:text-amber-700" data-testid="badge-inversione-qta-prezzo">
                                ⚠️ Quantità e prezzo forse invertiti: la quantità coincide con l'ultimo prezzo pagato, verifica la riga
                              </div>
                            )}
                            {prodotto.confronto_prezzo?.match_tipo === 'codice' && (
                              <div className="mb-2 px-2 py-1 bg-emerald-500/15 lg:bg-emerald-50 rounded-lg text-[11px] text-emerald-400 lg:text-emerald-700" data-testid="badge-match-codice">
                                🎯 Confronto per codice articolo
                              </div>
                            )}
                            {prodotto.confronto_prezzo?.trend === 'aumento' && (
                              <div className="mb-2 px-2 py-1 bg-red-500/15 lg:bg-red-50 rounded-lg text-[11px] text-red-400 lg:text-red-600 font-medium" data-testid="alert-aumento-prezzo">
                                ⚠️ Prezzo aumentato rispetto all'ultimo acquisto da questo fornitore
                              </div>
                            )}
                            {prodotto.confronto_prezzo?.alert_risparmio && (
                              <div className="mb-2 px-2 py-1.5 bg-amber-500/20 lg:bg-amber-50 rounded-lg text-xs text-amber-400 lg:text-amber-700 font-medium" data-testid="alert-risparmio-fornitore">
                                💡 Da {prodotto.confronto_prezzo.alert_risparmio.fornitore} l'hai pagato €{Number(prodotto.confronto_prezzo.alert_risparmio.prezzo).toFixed(2)} (−{prodotto.confronto_prezzo.alert_risparmio.risparmio_percentuale}%)
                              </div>
                            )}
                            
                            <div className="flex flex-wrap gap-2 text-xs">
                              {/* Quantità - editabile */}
                              <div className="flex items-center gap-1 bg-slate-700 lg:bg-gray-100 px-2 py-1 rounded">
                                <span className="text-slate-400 lg:text-gray-500">Qtà:</span>
                                <input
                                  type="number"
                                  step="0.01"
                                  value={prodotto.quantita}
                                  onChange={(e) => {
                                    const updated = [...prodottiVerifica];
                                    const newQta = parseFloat(e.target.value) || 0;
                                    updated[idx].quantita = newQta;
                                    updated[idx].totale = newQta * updated[idx].prezzo_unitario;
                                    setProdottiVerifica(updated);
                                  }}
                                  className="w-16 bg-transparent text-white lg:text-gray-900 font-medium text-right focus:outline-none"
                                />
                                <span className="text-white lg:text-gray-900">{prodotto.unita_misura}</span>
                              </div>
                              
                              {/* Prezzo - editabile */}
                              <div className={`flex items-center gap-1 px-2 py-1 rounded ${
                                prodotto.confronto_prezzo?.trend === 'aumento' 
                                  ? 'bg-red-500/30 lg:bg-red-100' 
                                  : prodotto.confronto_prezzo?.trend === 'diminuzione'
                                  ? 'bg-green-500/30 lg:bg-green-100'
                                  : 'bg-slate-700 lg:bg-gray-100'
                              }`}>
                                <span className="text-slate-400 lg:text-gray-500">€/u:</span>
                                <input
                                  type="number"
                                  step="0.01"
                                  value={prodotto.prezzo_unitario}
                                  onChange={(e) => {
                                    const updated = [...prodottiVerifica];
                                    const newPrezzo = parseFloat(e.target.value) || 0;
                                    updated[idx].prezzo_unitario = newPrezzo;
                                    updated[idx].totale = updated[idx].quantita * newPrezzo;
                                    setProdottiVerifica(updated);
                                  }}
                                  className="w-16 bg-transparent text-white lg:text-gray-900 font-medium text-right focus:outline-none"
                                />
                              </div>
                              
                              {/* Totale riga */}
                              <span className={`px-2 py-1 rounded font-medium ${
                                prodotto.stato_consegna === 'ricevuto' 
                                  ? 'bg-green-500/20 text-green-400 lg:bg-green-100 lg:text-green-700'
                                  : prodotto.stato_consegna === 'parziale'
                                  ? 'bg-yellow-500/20 text-yellow-400 lg:bg-yellow-100 lg:text-yellow-700'
                                  : 'bg-red-500/20 text-red-400 lg:bg-red-100 lg:text-red-700 line-through'
                              }`}>
                                €{(prodotto.stato_consegna === 'parziale' 
                                  ? (prodotto.quantita_ricevuta || 0) * (prodotto.prezzo_unitario || 0) 
                                  : prodotto.stato_consegna === 'ricevuto' 
                                  ? (prodotto.quantita || 0) * (prodotto.prezzo_unitario || 0)
                                  : 0).toFixed(2)}
                              </span>
                              
                              {/* Lotto */}
                              {prodotto.lotto && (
                                <span className="px-2 py-1 bg-blue-500/20 text-blue-400 lg:bg-blue-100 lg:text-blue-700 rounded">
                                  Lotto: {prodotto.lotto}
                                </span>
                              )}
                            </div>
                            
                            {/* Sezione Quantità Ricevuta (per parziale) */}
                            {prodotto.stato_consegna === 'parziale' && (
                              <div className="mt-2 p-2 bg-yellow-500/10 lg:bg-yellow-50 rounded-lg">
                                <div className="flex items-center gap-2 text-xs">
                                  <span className="text-yellow-400 lg:text-yellow-700">Qtà ricevuta:</span>
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max={prodotto.quantita_originale}
                                    value={prodotto.quantita_ricevuta || 0}
                                    onChange={(e) => {
                                      const updated = [...prodottiVerifica];
                                      updated[idx].quantita_ricevuta = parseFloat(e.target.value) || 0;
                                      setProdottiVerifica(updated);
                                    }}
                                    className="w-20 px-2 py-1 bg-black/40 backdrop-blur-md lg:bg-white border border-yellow-500/50 rounded text-white lg:text-gray-900 text-right"
                                  />
                                  <span className="text-yellow-400 lg:text-yellow-700">
                                    / {prodotto.quantita_originale} {prodotto.unita_misura}
                                  </span>
                                  <span className="text-red-400 lg:text-red-600 ml-2">
                                    (mancano {((prodotto.quantita_originale || 0) - (prodotto.quantita_ricevuta || 0)).toFixed(2)} {prodotto.unita_misura})
                                  </span>
                                </div>
                              </div>
                            )}
                            
                            {/* Sezione Reso (motivo + nota credito) */}
                            {prodotto.stato_consegna === 'reso' && (
                              <div className="mt-2 p-2 bg-orange-500/10 lg:bg-orange-50 rounded-lg space-y-2">
                                <div className="flex flex-col gap-1">
                                  <label className="text-xs text-orange-400 lg:text-orange-700">Motivo reso:</label>
                                  <input
                                    type="text"
                                    placeholder="Es: prodotto scaduto, danneggiato, errato..."
                                    value={prodotto.motivo_reso || ''}
                                    onChange={(e) => {
                                      const updated = [...prodottiVerifica];
                                      updated[idx].motivo_reso = e.target.value;
                                      setProdottiVerifica(updated);
                                    }}
                                    className="w-full px-2 py-1 bg-black/40 backdrop-blur-md lg:bg-white border border-orange-500/50 rounded text-white lg:text-gray-900 text-sm"
                                  />
                                </div>
                                <div className="flex items-center gap-2">
                                  <input
                                    type="checkbox"
                                    id={`nc_${idx}`}
                                    checked={prodotto.nota_credito_ricevuta || false}
                                    onChange={(e) => {
                                      const updated = [...prodottiVerifica];
                                      updated[idx].nota_credito_ricevuta = e.target.checked;
                                      setProdottiVerifica(updated);
                                    }}
                                    className="w-4 h-4 rounded border-orange-500"
                                  />
                                  <label htmlFor={`nc_${idx}`} className="text-xs text-orange-400 lg:text-orange-700">
                                    Nota credito ricevuta dal fornitore
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Riepilogo dettagliato */}
                  <div className="p-3 bg-slate-800/50 lg:bg-gray-50 rounded-xl border border-slate-700 lg:border-gray-200 space-y-2">
                    {/* Ricevuti */}
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-green-400 lg:text-green-700">
                        ✅ Ricevuti: {prodottiVerifica.filter(p => p.stato_consegna === 'ricevuto').length}
                      </span>
                      <span className="font-bold text-green-400 lg:text-green-700">
                        {formatCurrency(prodottiVerifica.filter(p => p.stato_consegna === 'ricevuto').reduce((sum, p) => sum + (p.totale || 0), 0))}
                      </span>
                    </div>
                    {/* Parziali */}
                    {prodottiVerifica.filter(p => p.stato_consegna === 'parziale').length > 0 && (
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-yellow-400 lg:text-yellow-700">
                          ⚠️ Parziali: {prodottiVerifica.filter(p => p.stato_consegna === 'parziale').length}
                        </span>
                        <span className="font-bold text-yellow-400 lg:text-yellow-700">
                          {formatCurrency(prodottiVerifica.filter(p => p.stato_consegna === 'parziale').reduce((sum, p) => sum + ((p.quantita_ricevuta || 0) * p.prezzo_unitario), 0))}
                        </span>
                      </div>
                    )}
                    {/* Non consegnati */}
                    {prodottiVerifica.filter(p => p.stato_consegna === 'non_consegnato').length > 0 && (
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-red-400 lg:text-red-700">
                          ❌ Non consegnati: {prodottiVerifica.filter(p => p.stato_consegna === 'non_consegnato').length}
                        </span>
                        <span className="font-bold text-red-400 lg:text-red-700 line-through">
                          {formatCurrency(prodottiVerifica.filter(p => p.stato_consegna === 'non_consegnato').reduce((sum, p) => sum + (p.totale || 0), 0))}
                        </span>
                      </div>
                    )}
                    {/* Resi */}
                    {prodottiVerifica.filter(p => p.stato_consegna === 'reso').length > 0 && (
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-orange-400 lg:text-orange-700">
                          ↩️ Resi: {prodottiVerifica.filter(p => p.stato_consegna === 'reso').length}
                        </span>
                        <span className="font-bold text-orange-400 lg:text-orange-700 line-through">
                          {formatCurrency(prodottiVerifica.filter(p => p.stato_consegna === 'reso').reduce((sum, p) => sum + (p.totale || 0), 0))}
                        </span>
                      </div>
                    )}
                    {/* Totale effettivo */}
                    <div className="pt-2 border-t border-slate-600 lg:border-gray-300 flex items-center justify-between">
                      <span className="font-bold text-white lg:text-gray-900">TOTALE EFFETTIVO:</span>
                      <span className="font-bold text-lg text-green-400 lg:text-green-700">
                        {formatCurrency(
                          prodottiVerifica.filter(p => p.stato_consegna === 'ricevuto').reduce((sum, p) => sum + (p.totale || 0), 0) +
                          prodottiVerifica.filter(p => p.stato_consegna === 'parziale').reduce((sum, p) => sum + ((p.quantita_ricevuta || 0) * p.prezzo_unitario), 0)
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Footer - FISSO in basso SOPRA bottom nav su mobile */}
            <div className="fixed lg:relative lg:bottom-0 safe-footer left-0 right-0 p-4 border-t border-slate-700 lg:border-gray-200 bg-black/60 backdrop-blur-md lg:bg-white flex-shrink-0 z-[101]">
              {step === 1 && (
                <div className="flex flex-col gap-2">
                  <button 
                    onClick={() => setStep(2)} 
                    disabled={!selectedOrdine} 
                    className="w-full py-3 bg-purple-600 hover:bg-purple-700 disabled:opacity-50 text-white rounded-xl font-medium"
                  >
                    Conferma Ordine
                  </button>
                  <button 
                    onClick={() => { setSelectedOrdine(null); setStep(2); }} 
                    className="w-full py-3 bg-black/40 backdrop-blur-md lg:bg-gray-100 hover:bg-slate-700 lg:hover:bg-gray-200 text-purple-400 lg:text-purple-600 rounded-xl font-medium border border-purple-500/30 lg:border-purple-600"
                  >
                    Procedi senza ordine
                  </button>
                </div>
              )}
              {step === 2 && (
                <div className="flex gap-2">
                  <button 
                    onClick={() => setStep(1)} 
                    className="flex-1 py-3 bg-black/40 backdrop-blur-md lg:bg-gray-100 text-white lg:text-gray-700 rounded-xl font-medium"
                  >
                    Indietro
                  </button>
                  {analisiResult && !selectedOrdine && (
                    <button 
                      onClick={() => salvaDDT(false)} 
                      disabled={savingDDT}
                      data-testid="salva-ddt-btn"
                      className="flex-1 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-500 disabled:cursor-not-allowed text-white rounded-xl font-medium flex items-center justify-center gap-2"
                    >
                      {savingDDT ? (
                        <>
                          <Loader2 className="h-4 w-4 animate-spin" />
                          Salvataggio...
                        </>
                      ) : (
                        <>
                          <CheckCircle className="h-4 w-4" />
                          Salva
                        </>
                      )}
                    </button>
                  )}
                </div>
              )}
              {step === 3 && (
                <div className="flex gap-2">
                  {showReviewMode && analisiMultiple.length > 1 ? (
                    /* Pulsanti per upload multiplo */
                    <>
                      <button 
                        onClick={saltaDDTCorrente} 
                        className="flex-1 py-3 bg-black/40 backdrop-blur-md lg:bg-gray-100 text-white lg:text-gray-700 rounded-xl font-medium"
                      >
                        Salta
                      </button>
                      <button 
                        onClick={salvaDDTCorrenteEProsegui}
                        disabled={savingDDT}
                        className="flex-1 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-500 text-white rounded-xl font-medium flex items-center justify-center gap-2"
                      >
                        {savingDDT ? (
                          <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                          <>
                            <CheckCircle className="h-4 w-4" />
                            Salva e Prosegui
                          </>
                        )}
                      </button>
                    </>
                  ) : (
                    /* Pulsanti per upload singolo */
                    <>
                      <button 
                        onClick={() => setStep(2)} 
                        className="flex-1 py-3 bg-black/40 backdrop-blur-md lg:bg-gray-100 text-white lg:text-gray-700 rounded-xl font-medium"
                      >
                        Indietro
                      </button>
                      <button 
                        onClick={() => salvaDDT(true)} 
                        disabled={savingDDT}
                        data-testid="conferma-ddt-btn"
                        className="flex-1 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-500 disabled:cursor-not-allowed text-white rounded-xl font-medium flex items-center justify-center gap-2"
                      >
                        {savingDDT ? (
                          <>
                            <Loader2 className="h-4 w-4 animate-spin" />
                            Salvataggio...
                          </>
                        ) : (
                          <>
                            <CheckCircle className="h-4 w-4" />
                            Conferma
                          </>
                        )}
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal: Visualizza Immagine */}
      {showImmagine && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setShowImmagine(null)}>
          <div className="relative max-w-4xl max-h-[90vh]">
            <Button variant="ghost" size="sm" className="absolute -top-10 right-0 text-white" onClick={() => setShowImmagine(null)}>
              <X className="h-6 w-6" />
            </Button>
            <img src={showImmagine} alt="DDT" className="max-h-[85vh] rounded-lg" />
          </div>
        </div>
      )}

      {/* Click outside to close action menu */}
      {actionMenuOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setActionMenuOpen(null)} />
      )}
    </div>
  );
};

export default GestioneBollePage;
